webpackJsonp([1],{

/***/ 105:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);


var status = {
    toString: function toString(number) {
        switch (number) {
            case 1:
                return 'Öppen';
            case 2:
                return 'Avslutad';
            case 3:
                return 'Planerad';
            case 4:
                return 'Pågende';
            case 5:
                return 'Avvakta';
            case 6:
                return 'Klar';
            default:
                return 'Öppen';
        }
    }
};

var sharedStatus = {
    toString: function toString(number) {
        switch (number) {
            case 0:
                return 'Nej';
            case 1:
                return 'Skickad';
            case 2:
                return 'Mottagen';
            case 3:
                return 'Läst';
            case 4:
                return 'Accepterad';
            case 5:
                return 'Nekad';
            case 6:
                return 'Klar';
            case 7:
                return 'Avslutad';
            default:
                return 'Felaktig';
        }
    }
};

var task = {
    toBody: function toBody(task) {
        var body = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.pick(task, ['categories', 'tags', 'content', 'status', 'shared_status', 'user_limit', 'deadline']);

        if (task.workarea) {
            body.workarea = task.workarea;
        }

        body.users = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.map(task.users, function (item) {
            return { username: item.username };
        });

        return body;
    },
    getCreator: function getCreator(task) {
        return __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.find(task.users, { creator: true });
    },
    getCreatedTimeFull: function getCreatedTimeFull(task) {
        return task.created_at === null ? 'Aldrig' : new Date(task.created_at).toLocaleString('sv-SE', { year: 'numeric', month: 'numeric', day: 'numeric', hour: '2-digit', minute: '2-digit', second: '2-digit' });
    },
    getUpdatedTimeFull: function getUpdatedTimeFull(task) {
        return task.updated_at === null ? 'Aldrig' : new Date(task.updated_at).toLocaleString('sv-SE', { year: 'numeric', month: 'numeric', day: 'numeric', hour: '2-digit', minute: '2-digit', second: '2-digit' });
    },
    getCreatedTime: function getCreatedTime(task) {
        return task.created_at === null ? 'Aldrig' : new Date(task.created_at).toLocaleString('sv-SE', { year: 'numeric', month: 'numeric', day: 'numeric' });
    },
    getUpdatedTime: function getUpdatedTime(task) {
        return task.updated_at === null ? 'Aldrig' : new Date(task.updated_at).toLocaleString('sv-SE', { year: 'numeric', month: 'numeric', day: 'numeric' });
    },
    getSentTime: function getSentTime(task) {
        return task.sent_at === null ? 'Aldrig' : new Date(task.sent_at).toLocaleString('sv-SE', { year: 'numeric', month: 'numeric', day: 'numeric' });
    },
    getSentTimeFull: function getSentTimeFull(task) {
        return task.sent_at === null ? 'Aldrig' : new Date(task.sent_at).toLocaleString('sv-SE', { year: 'numeric', month: 'numeric', day: 'numeric', hour: '2-digit', minute: '2-digit', second: '2-digit' });
    },
    formatTime: function formatTime(time) {
        return time === null || time === undefined ? 'Aldrig' : new Date(time).toLocaleString('sv-SE', { year: 'numeric', month: 'numeric', day: 'numeric' });
    },
    formatTimeFull: function formatTimeFull(time) {
        return time === null || time === undefined ? 'Aldrig' : new Date(time).toLocaleString('sv-SE', { year: 'numeric', month: 'numeric', day: 'numeric', hour: '2-digit', minute: '2-digit', second: '2-digit' });
    },
    hasDeadlineFilter: function hasDeadlineFilter(task, filter) {
        if (filter === 'all') {
            return true;
        }

        console.log(filter, new Date(task.deadline) > Date.now(), new Date(task.deadline) < Date.now());

        if (filter === 'due' && task.deadline !== undefined && task.deadline !== null && new Date(task.deadline) < new Date()) {
            return true;
        }

        if (filter === 'rest' && task.deadline !== undefined && task.deadline !== null && new Date(task.deadline) > new Date()) {
            return true;
        }

        return false;
    },
    getLowestSharedStatus: function getLowestSharedStatus(task) {
        var status = 10;

        __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.each(task.users, function (user) {
            if (user.shared_status < status && user.user !== task.creator && user.shared_status !== task.shared_status) {
                status = user.shared_status;
            }
        });

        if (status === 10) {
            status = task.shared_status;
        }

        return status;
    },
    isReceived: function isReceived(task, user, workarea) {
        if (task.creator === user.id) {
            return false;
        }

        if (task.users && task.users.length > 1) {
            var receiver = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.find(task.users, { user: user.id });

            if (receiver) {
                return true;
            }

            if (workarea !== null && workarea !== 'Ingen') {
                var member = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.find(workarea.members, { id: task.creator });

                if (member === null || member === undefined) {
                    return true;
                } else {
                    return false;
                }
            }
        }

        return false;
    },
    getCorrectStatus: function getCorrectStatus(tsk, user, workarea, state) {
        if (tsk.users && tsk.users.length > 1) {
            var self = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.find(tsk.users, { user: user.id });

            if (self !== undefined && self !== null) {
                return self.status;
            }

            if (workarea !== null && workarea !== undefined) {
                var _user = void 0;
                __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.each(workarea.members, function (member) {
                    if (_user === null || _user === undefined) {
                        _user = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.find(tsk.users, { user: member.id });
                    }
                });

                if (_user !== null && _user !== undefined) {
                    return _user.status;
                }
            } else {
                if (tsk.workarea !== null && tsk.workarea !== undefined) {
                    workarea = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.find(state, { id: tsk.workarea });

                    if (workarea !== null && workarea !== undefined) {
                        var _user2 = void 0;
                        __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.each(workarea.members, function (member) {
                            if (_user2 === null || _user2 === undefined) {
                                _user2 = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.find(tsk.users, { user: member.id });
                            }
                        });

                        if (_user2 !== null && _user2 !== undefined) {
                            return _user2.status;
                        } else {
                            return tsk.status;
                        }
                    }
                } else {
                    return tsk.status;
                }
            }
        } else {
            return tsk.status;
        }
    },
    isSent: function isSent(tsk, user, workarea) {
        if (tsk.users && tsk.users.length > 1) {
            if (tsk.creator === user.id) {
                return true;
            }

            if (workarea !== null && workarea !== 'Ingen') {
                var member = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.find(workarea.members, { id: tsk.creator });

                if (member) {
                    return true;
                }
            }
        }

        return false;
    },
    hasCorrectSharedStatus: function hasCorrectSharedStatus(tsk, shared, user, workarea) {
        if (shared === 'all') {
            return true;
        } else if (shared === 'non' && tsk.users && tsk.users.length <= 1) {
            return true;
        } else if (shared === 'sent' && task.isSent(tsk, user, workarea)) {
            return true;
        } else if (shared === 'received' && task.isReceived(tsk, user, workarea)) {
            return true;
        } else if (shared === 'rejected' && tsk.users && tsk.users.length > 1 && task.getLowestSharedStatus(tsk) === 5) {
            return true;
        } else if (shared === 'accepted' && tsk.users && tsk.users.length > 1 && task.getLowestSharedStatus(tsk) === 4) {
            return true;
        } else if (shared === 'done' && tsk.users && tsk.users.length > 1 && task.getLowestSharedStatus(tsk) === 6) {
            return true;
        } else if (shared === 'read' && tsk.users && tsk.users.length > 1 && task.getLowestSharedStatus(tsk) === 3) {
            return true;
        } else {
            return false;
        }
    },
    isIncommingMessage: function isIncommingMessage(task, user, message, workareas) {
        if (task.workarea !== undefined && task.workarea !== null) {
            var workarea = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.find(workareas, { id: task.workarea });

            if (workarea !== undefined && workarea !== null) {
                var member = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.find(workarea.members, { username: message.user });

                if (member !== undefined && member !== null) {
                    return false;
                } else {
                    return true;
                }
            } else {
                if (message.user === user.username) {
                    return false;
                } else {
                    return true;
                }
            }
        } else if (message.user === user.username) {
            return false;
        } else {
            return true;
        }
    }
};

/* harmony default export */ __webpack_exports__["a"] = ({
    status: status,
    sharedStatus: sharedStatus,
    task: task
});

/***/ }),

/***/ 107:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Autocomplete_vue__ = __webpack_require__(261);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_20a28143_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Autocomplete_vue__ = __webpack_require__(262);
function injectStyle (ssrContext) {
  __webpack_require__(260)
}
var normalizeComponent = __webpack_require__(10)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Autocomplete_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_20a28143_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Autocomplete_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 140:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(212);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);



var userRegex = /(@@?)([^\s]+)/g;
var metadataRegex = /([+#])([^\s]+)/g;

/* harmony default export */ __webpack_exports__["a"] = ({
    parse: function parse(context, content) {
        var workarea = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
        var maxRecv = arguments[3];
        var allowZero = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;

        var wid = workarea;

        if ((typeof workarea === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(workarea)) === 'object' && workarea !== null) {
            wid = workarea.id;
        }

        var task = {
            content: content,
            workarea: wid,
            users: [],
            tags: [],
            categories: [],
            user_limit: null
        };

        if (maxRecv !== null && maxRecv !== undefined && (maxRecv > 0 || maxRecv === '0' && allowZero)) {
            task.user_limit = maxRecv;
        }

        var metadata = content.match(metadataRegex);
        if (metadata) {
            __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.each(metadata, function (meta) {
                var name = meta.substring(1);
                switch (meta[0]) {
                    case '#':
                        task.tags = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.union(task.tags, [name]);
                        break;
                    case '+':
                        task.categories = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.union(task.categories, [name]);
                        break;
                }
            });
        }

        var users = content.match(userRegex);
        if (users) {
            __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.each(users, function (user) {
                var name = user.substring(1);

                switch (name[0]) {
                    case '@':
                        {
                            var group = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.find(context.$store.state.group.groups, { name: name.substring(1) });

                            if (group) {
                                task.users = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.union(task.users, __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.map(group.members, function (item) {
                                    return { username: item.username };
                                }));
                            }

                            break;
                        }
                    default:
                        {
                            var friend = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.find(context.$store.state.friend.friends, { username: name });

                            if (friend) {
                                task.users = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.union(task.users, [friend]);
                            }

                            break;
                        }
                }
            });
        }

        return task;
    }
});

/***/ }),

/***/ 149:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AtTextarea_vue__ = __webpack_require__(232);
var normalizeComponent = __webpack_require__(10)
/* script */

/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AtTextarea_vue__["a" /* default */],
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 150:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["g"] = scrollIntoView;
/* harmony export (immutable) */ __webpack_exports__["a"] = applyRange;
/* harmony export (immutable) */ __webpack_exports__["f"] = getRange;
/* harmony export (immutable) */ __webpack_exports__["c"] = getAtAndIndex;
/* harmony export (immutable) */ __webpack_exports__["d"] = getOffset;
/* harmony export (immutable) */ __webpack_exports__["b"] = closest;
/* harmony export (immutable) */ __webpack_exports__["e"] = getPrecedingRange;

function scrollIntoView(el, scrollParent) {
    if (el.scrollIntoViewIfNeeded) {
        el.scrollIntoViewIfNeeded(false);
    } else {
        var diff = el.offsetTop - scrollParent.scrollTop;
        if (diff < 0 || diff > scrollParent.offsetHeight - el.offsetHeight) {
            scrollParent = scrollParent || el.parentElement;
            scrollParent.scrollTop = el.offsetTop;
        }
    }
}

function applyRange(range) {
    var selection = window.getSelection();
    if (selection) {
        selection.removeAllRanges();
        selection.addRange(range);
    }
}
function getRange() {
    var selection = window.getSelection();
    if (selection && selection.rangeCount > 0) {
        return selection.getRangeAt(0);
    }
}

function getAtAndIndex(text, ats) {
    return ats.map(function (at) {
        return { at: at, index: text.indexOf(at) };
    }).reduce(function (a, b) {
        return a.index > b.index ? a : b;
    });
}

function getOffset(element, target) {
    target = target || window;
    var offset = { top: element.offsetTop, left: element.offsetLeft },
        parent = element.offsetParent;
    while (parent != null && parent != target) {
        offset.left += parent.offsetLeft;
        offset.top += parent.offsetTop;
        parent = parent.offsetParent;
    }
    return offset;
}

function closest(el, predicate) {
    do {
        if (predicate(el)) return el;
    } while (el = el && el.parentNode);
}

function getPrecedingRange() {
    var r = getRange();
    if (r) {
        var range = r.cloneRange();
        range.collapse(true);

        range.setStart(range.endContainer, 0);
        return range;
    }
}

/***/ }),

/***/ 153:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__bugsnag__ = __webpack_require__(29);


var timeout = void 0;
var errorCount = 0;

function timedFunction(func, time) {
    return function () {
        console.log('TIMER RUNNING FUNCTION');
        try {
            func();
            errorCount = 0;
        } catch (error) {
            __WEBPACK_IMPORTED_MODULE_1__bugsnag__["a" /* default */].notify(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(error));
            errorCount += 1;
        }
        if (errorCount < 10) {
            timeout = setTimeout(timedFunction(func, time), time);
        } else {
            stopTimedFunction();
        }
    };
}

function startTimedFunction(func, time) {
    console.log('TIMER STARTING');
    if (timeout === null || timeout === undefined) {
        try {
            func();
            errorCount = 0;
        } catch (error) {
            __WEBPACK_IMPORTED_MODULE_1__bugsnag__["a" /* default */].notify(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(error));
            errorCount += 1;
        }
        if (errorCount < 10) {
            timeout = setTimeout(timedFunction(func, time), time);
            console.log('STARTED TIMER: ', timeout);
        } else {
            stopTimedFunction();
        }
    }
}

function stopTimedFunction() {
    console.log('STOPPING TIMER: ', timeout);
    clearTimeout(timeout);
    timeout = null;
}

function hasTimedFunction() {
    return timeout !== null && timeout !== undefined;
}

/* harmony default export */ __webpack_exports__["a"] = ({
    startTimedFunction: startTimedFunction,
    stopTimedFunction: stopTimedFunction,
    hasTimedFunction: hasTimedFunction
});

/***/ }),

/***/ 154:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex_persistedstate__ = __webpack_require__(273);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex_persistedstate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vuex_persistedstate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__vuex_modules_task__ = __webpack_require__(274);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__vuex_modules_authentication__ = __webpack_require__(275);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__vuex_modules_friend__ = __webpack_require__(291);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__vuex_modules_group__ = __webpack_require__(292);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__vuex_modules_workarea__ = __webpack_require__(293);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__vuex_modules_filter__ = __webpack_require__(294);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__vuex_modules_favorites__ = __webpack_require__(295);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__vuex_modules_organisations__ = __webpack_require__(296);












__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
    modules: {
        task: __WEBPACK_IMPORTED_MODULE_3__vuex_modules_task__["a" /* default */],
        authentication: __WEBPACK_IMPORTED_MODULE_4__vuex_modules_authentication__["a" /* default */],
        friend: __WEBPACK_IMPORTED_MODULE_5__vuex_modules_friend__["a" /* default */],
        group: __WEBPACK_IMPORTED_MODULE_6__vuex_modules_group__["a" /* default */],
        workarea: __WEBPACK_IMPORTED_MODULE_7__vuex_modules_workarea__["a" /* default */],
        filter: __WEBPACK_IMPORTED_MODULE_8__vuex_modules_filter__["a" /* default */],
        favorites: __WEBPACK_IMPORTED_MODULE_9__vuex_modules_favorites__["a" /* default */],
        organisations: __WEBPACK_IMPORTED_MODULE_10__vuex_modules_organisations__["a" /* default */]
    },
    plugins: [__WEBPACK_IMPORTED_MODULE_2_vuex_persistedstate___default()()]
}));

/***/ }),

/***/ 194:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(198);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_resource__ = __webpack_require__(308);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_bootstrap_vue_dist_bootstrap_vue_esm__ = __webpack_require__(310);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__vuex_store__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vee_validate__ = __webpack_require__(313);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_datetime__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_datetime___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vue_datetime__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__bugsnag__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_bugsnag_vue__ = __webpack_require__(314);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_bugsnag_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_bugsnag_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_babel_polyfill__ = __webpack_require__(315);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_babel_polyfill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_babel_polyfill__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_bootstrap_dist_css_bootstrap_css__ = __webpack_require__(517);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_bootstrap_dist_css_bootstrap_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_bootstrap_dist_css_bootstrap_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_bootstrap_vue_dist_bootstrap_vue_css__ = __webpack_require__(518);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_bootstrap_vue_dist_bootstrap_vue_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_bootstrap_vue_dist_bootstrap_vue_css__);


















__WEBPACK_IMPORTED_MODULE_9__bugsnag__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_10_bugsnag_vue___default()(__WEBPACK_IMPORTED_MODULE_9__bugsnag__["a" /* default */]));

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.productionTip = false;

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_3_vue_resource__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_4_bootstrap_vue_dist_bootstrap_vue_esm__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_7_vee_validate__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_8_vue_datetime___default.a);

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.options.root = "https://api.plusflow.me/v1";

__WEBPACK_IMPORTED_MODULE_5__vuex_store__["a" /* default */].subscribe(function (mutation, state) {
    if (mutation.type === 'INSERT_GROUP_LIST') {
        __WEBPACK_IMPORTED_MODULE_6_lodash___default.a.each(mutation.payload, function (group, index) {
            __WEBPACK_IMPORTED_MODULE_5__vuex_store__["a" /* default */].dispatch('group_members', { group: group, index: index });
        });
    }
});

new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
    el: '#app',
    store: __WEBPACK_IMPORTED_MODULE_5__vuex_store__["a" /* default */],
    router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
    template: '<App/>',
    components: {
        App: __WEBPACK_IMPORTED_MODULE_1__App__["a" /* default */]
    }
});

/***/ }),

/***/ 198:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_79a41f78_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(307);
function injectStyle (ssrContext) {
  __webpack_require__(199)
}
var normalizeComponent = __webpack_require__(10)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_79a41f78_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 199:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 201:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_timeout__ = __webpack_require__(153);







/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'app',
    computed: {
        authenticated: function authenticated() {
            return this.$store.state.authentication.authenticated;
        },
        user: function user() {
            return this.$store.state.authentication.user;
        }
    },
    mounted: function mounted() {
        if (this.$store.state.authentication.authenticated) {
            __WEBPACK_IMPORTED_MODULE_3__utils_timeout__["a" /* default */].startTimedFunction(this.refresh, 1000 * 30 * 1);
        }
    },
    destroyed: function destroyed() {
        __WEBPACK_IMPORTED_MODULE_3__utils_timeout__["a" /* default */].stopTimedFunction();
    },

    methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])({
        logoutFunction: 'auth_logout',
        refreshFriends: 'friend_list',
        refreshGroups: 'group_list',
        refreshWorkareas: 'workarea_list',
        refreshTasks: 'task_list',
        refreshFavorites: 'favorites_list'
    }), Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["d" /* mapMutations */])({
        resetFilters: 'FILTER_RESET',
        resetFriends: 'FRIEND_RESET',
        resetGroups: 'GROUP_RESET',
        resetWorkareas: 'WORKAREA_RESET',
        resetTasks: 'RESET_TASK',
        resetFavorites: 'RESET_FAVORITES'
    }), {
        refresh: function refresh() {
            this.refreshFavorites();
            if (this.$store.state.task.syncing !== true) {
                this.refreshTasks({ offset: 0 });
            }
        },
        reset: function reset() {
            this.resetFilters();
            this.resetFriends();
            this.resetGroups();
            this.resetWorkareas();
            this.resetTasks();
            this.resetFavorites();
        },
        logout: function logout() {
            var _this = this;

            this.logoutFunction().then(function () {
                localStorage.clear();
                _this.reset();
                __WEBPACK_IMPORTED_MODULE_3__utils_timeout__["a" /* default */].stopTimedFunction();
                __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push('/login');
            });
        }
    })
});

/***/ }),

/***/ 208:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Main_vue__ = __webpack_require__(210);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7bc00bba_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Main_vue__ = __webpack_require__(241);
function injectStyle (ssrContext) {
  __webpack_require__(209)
}
var normalizeComponent = __webpack_require__(10)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Main_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7bc00bba_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Main_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 209:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 210:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_parser__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_addins_AtTextarea__ = __webpack_require__(149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_parts_Task__ = __webpack_require__(237);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_datetime__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_datetime___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_datetime__);










/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'main',
    components: {
        AtTextarea: __WEBPACK_IMPORTED_MODULE_4__components_addins_AtTextarea__["a" /* default */],
        Task: __WEBPACK_IMPORTED_MODULE_5__components_parts_Task__["a" /* default */],
        Datetime: __WEBPACK_IMPORTED_MODULE_6_vue_datetime__["Datetime"]
    },
    data: function data() {
        return {
            content: '',
            selected: 'Ingen',
            search: '',
            removeTask: null,
            orderKey: 'created_at',
            order: 'asc',
            searchinter: '',
            selectedFilter: {},
            shared: 'all',
            maxRecv: 0,
            deadline: null,
            deadlineShow: 'all',
            sharedOptions: [{
                text: 'Alla uppgifter',
                value: 'all'
            }, {
                text: 'Inte delade',
                value: 'non'
            }, {
                text: 'Mottagna',
                value: 'received'
            }, {
                text: 'Skickade',
                value: 'sent'
            }, {
                text: 'Lästa',
                value: 'read'
            }, {
                text: 'Accepterade',
                value: 'accepted'
            }, {
                text: 'Avvisade',
                value: 'rejected'
            }, {
                text: 'Klara',
                value: 'done'
            }],
            deadlineOptions: [{
                text: 'Alla uppgifter',
                value: 'all'
            }, {
                text: 'Förfallna',
                value: 'due'
            }, {
                text: 'Inte förfallna',
                value: 'rest'
            }]
        };
    },

    computed: {
        tasks: function tasks() {
            return this.$store.getters.getFilteredTasks(this.search, this.orderKey, this.order, this.selectedFilter, this.shared, this.favorites, this.deadlineShow);
        },
        filterList: function filterList() {
            var tasks = this.$store.getters.getFilteredTasks(this.search, this.orderKey, this.order, {}, 'all', this.favorites, 'all');
            var list = {};

            __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.each(tasks, function (task) {
                if (task.categories && task.categories.length > 0) {
                    __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.each(task.categories, function (category) {
                        list[category] = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.union(list[category], task.tags);
                    });
                } else {
                    list[''] = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.union(list[''], task.tags);
                }
            });

            return list;
        },
        workareas: function workareas() {
            return this.$store.state.workarea.workareas;
        },
        statuses: function statuses() {
            return this.$store.state.filter.statuses;
        },
        workarea: function workarea() {
            return this.$store.state.filter.workarea;
        },
        favorites: function favorites() {
            return this.$store.state.favorites.favorites;
        }
    },
    mounted: function mounted() {
        if (this.$store.state.task.syncing !== true) {
            this.list({ offset: 0 });
        }

        this.selected = this.workarea === null ? 'Ingen' : this.workarea;
    },

    watch: {
        selected: function selected() {
            this.updateWorkarea(this.selected === 'Ingen' ? null : this.selected);
        }
    },
    methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])({
        list: 'task_list',
        get: 'task_get',
        remove: 'task_delete',
        insert: 'task_post',
        select: 'task_select'
    }), Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["d" /* mapMutations */])({
        updateStatuses: 'FILTER_SET_STATUSES',
        updateWorkarea: 'FILTER_SET_WORKAREA'
    }), Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapGetters */])({
        getFriends: 'getFriendsList'
    }), {
        create: function create() {
            var task = __WEBPACK_IMPORTED_MODULE_3__utils_parser__["a" /* default */].parse(this, this.content, this.workarea, this.maxRecv);

            this.content = '';

            task.deadline = this.deadline;

            this.insert(task);

            this.$refs.createTask.hide();
        },
        getAutocompleteList: function getAutocompleteList() {
            var friend = this.getFriends();
            var groups = this.$store.state.group.groups;

            groups = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.map(groups, function (g) {
                return '@' + g.name;
            });

            return __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.concat(friend, groups);
        },
        sendTask: function sendTask(task) {
            this.content = task.content;
            this.$refs.createTask.show();
        },
        filter: function filter(event) {
            var status = parseInt(event.target.value);
            var remove = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.filter(this.statuses, function (elem) {
                return elem !== status;
            });
            if (remove.length === this.statuses.length) {
                this.updateStatuses(__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.concat(this.statuses, status));
            } else {
                this.updateStatuses(remove);
            }
        },
        removeAction: function removeAction() {
            this.remove(this.removeTask);
        },
        setRemoveTask: function setRemoveTask(_ref) {
            var task = _ref.task,
                index = _ref.index;

            this.removeTask = { task: task, index: index };
            this.$refs.removeConfirmation.show();
        },
        removeCancel: function removeCancel() {
            this.removeTask = null;
        },
        reverseOrder: function reverseOrder(orderKey) {
            this.orderKey = orderKey;
            this.order = this.order === 'asc' ? 'desc' : 'asc';
        },
        selectFilter: function selectFilter(_ref2) {
            var tag = _ref2.tag,
                category = _ref2.category;

            this.selectedFilter = { tag: tag, category: category };
        },
        resetEditor: function resetEditor() {
            this.content = '';
            this.$refs.createTask.hide();
        },
        setSearchString: function setSearchString() {
            this.search = this.searchinter;
        },
        setDeadline: function setDeadline() {
            this.deadline = new Date().toLocaleString();
        }
    })
});

/***/ }),

/***/ 232:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__At_vue__ = __webpack_require__(233);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_textarea_caret__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_textarea_caret___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_textarea_caret__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util__ = __webpack_require__(150);





/* harmony default export */ __webpack_exports__["a"] = ({
    extends: __WEBPACK_IMPORTED_MODULE_0__At_vue__["a" /* default */],
    name: 'AtTextarea',

    computed: {
        style: function style() {
            if (this.atwho) {
                var _atwho = this.atwho,
                    x = _atwho.x,
                    y = _atwho.y;
                var wrap = this.$refs.wrap;

                var el = this.$el.querySelector('textarea');
                if (wrap) {
                    var left = x + el.offsetLeft - el.scrollLeft + 'px';
                    var top = y + el.offsetTop - el.scrollTop + 'px';
                    return { left: left, top: top };
                }
            }
            return null;
        }
    },

    methods: {
        handleDelete: function handleDelete(e) {
            var el = this.$el.querySelector('textarea');
            var text = el.value.slice(0, el.selectionEnd);
            if (text) {
                var atItems = this.atItems,
                    members = this.members,
                    deleteMatch = this.deleteMatch,
                    itemName = this.itemName;

                var _getAtAndIndex = Object(__WEBPACK_IMPORTED_MODULE_2__util__["c" /* getAtAndIndex */])(text, atItems),
                    at = _getAtAndIndex.at,
                    index = _getAtAndIndex.index;

                if (index > -1) {
                    var chunk = text.slice(index + at.length, -1);
                    var has = members.some(function (v) {
                        var name = itemName(v);
                        return deleteMatch(name, chunk);
                    });
                    if (has) {
                        el.value = el.value.slice(0, index) + el.value.slice(el.selectionEnd - 1);
                        el.selectionStart = index + 1;
                        el.selectionEnd = index + 1;
                    }
                }
            }
        },
        handleInput: function handleInput() {
            if (this.hasComposition) return;
            var el = this.$el.querySelector('textarea');
            var text = el.value.slice(0, el.selectionEnd);
            if (text) {
                var atItems = this.atItems,
                    avoidEmail = this.avoidEmail,
                    allowSpaces = this.allowSpaces;

                var show = true;

                var _getAtAndIndex2 = Object(__WEBPACK_IMPORTED_MODULE_2__util__["c" /* getAtAndIndex */])(text, atItems),
                    at = _getAtAndIndex2.at,
                    index = _getAtAndIndex2.index;

                if (index < 0) show = false;
                var prev = text[index - 1];
                var chunk = text.slice(index + at.length, text.length);
                if (avoidEmail) {
                    if (/^[a-z0-9]$/i.test(prev)) show = false;
                }
                if (!allowSpaces && /\s/.test(chunk)) {
                    show = false;
                }

                if (/^\s/.test(chunk)) show = false;
                if (!show) {
                    this.closePanel();
                } else {
                    var members = this.members,
                        filterMatch = this.filterMatch,
                        itemName = this.itemName;

                    var matched = members.filter(function (v) {
                        var name = itemName(v);
                        return filterMatch(name, chunk, at);
                    });
                    if (matched.length) {
                        this.openPanel(matched, chunk, index, at);
                    } else {
                        this.closePanel();
                    }
                }
            }
        },
        openPanel: function openPanel(list, chunk, offset, at) {
            var _this = this;

            var fn = function fn() {
                var el = _this.$el.querySelector('textarea');
                var end = offset + at.length;
                var rect = __WEBPACK_IMPORTED_MODULE_1_textarea_caret___default()(el, end);
                _this.atwho = {
                    chunk: chunk,
                    offset: offset,
                    list: list,
                    x: rect.left,
                    y: rect.top - 4,
                    cur: 0 };
            };
            if (this.atwho) {
                fn();
            } else {
                setTimeout(fn, 10);
            }
        },
        insertItem: function insertItem() {
            var _atwho2 = this.atwho,
                chunk = _atwho2.chunk,
                list = _atwho2.list,
                cur = _atwho2.cur;
            var atItems = this.atItems,
                itemName = this.itemName;

            var el = this.$el.querySelector('textarea');
            var text = el.value.slice(0, el.selectionEnd);

            var _getAtAndIndex3 = Object(__WEBPACK_IMPORTED_MODULE_2__util__["c" /* getAtAndIndex */])(text, atItems),
                at = _getAtAndIndex3.at,
                index = _getAtAndIndex3.index;

            var start = index + at.length;
            el.value = el.value.slice(0, start) + el.value.slice(start + chunk.length);
            el.selectionStart = start;
            el.selectionEnd = start;
            el.focus();
            document.execCommand('insertText', 0, itemName(list[cur]) + ' ');
        }
    }
});

/***/ }),

/***/ 233:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_At_vue__ = __webpack_require__(235);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4faaa0fa_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_At_vue__ = __webpack_require__(236);
function injectStyle (ssrContext) {
  __webpack_require__(234)
}
var normalizeComponent = __webpack_require__(10)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_At_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4faaa0fa_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_At_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 234:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 235:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util__ = __webpack_require__(150);





/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'At',
    props: {
        at: {
            type: String,
            default: null
        },
        ats: {
            type: Array,
            default: function _default() {
                return ['@'];
            }
        },
        allowSpaces: {
            type: Boolean,
            default: true
        },
        avoidEmail: {
            type: Boolean,
            default: true
        },
        hoverSelect: {
            type: Boolean,
            default: true
        },
        members: {
            type: Array,
            default: function _default() {
                return [];
            }
        },
        nameKey: {
            type: String,
            default: ''
        },
        filterMatch: {
            type: Function,
            default: function _default(name, chunk, at) {
                return name.toLowerCase().indexOf(chunk.toLowerCase()) > -1;
            }
        },
        deleteMatch: {
            type: Function,
            default: function _default(name, chunk) {
                return name === chunk;
            }
        }
    },

    data: function data() {
        return {
            hasComposition: false,
            atwho: null
        };
    },

    computed: {
        atItems: function atItems() {
            return this.at ? [this.at] : this.ats;
        },
        style: function style() {
            if (this.atwho) {
                var _atwho = this.atwho,
                    x = _atwho.x,
                    y = _atwho.y;
                var wrap = this.$refs.wrap;

                if (wrap) {
                    var offset = Object(__WEBPACK_IMPORTED_MODULE_1__util__["d" /* getOffset */])(wrap);
                    var left = x + window.pageXOffset - offset.left + 'px';
                    var top = y + window.pageYOffset - offset.top + 'px';
                    return { left: left, top: top };
                }
            }
            return null;
        }
    },
    watch: {
        'atwho.cur': function atwhoCur(index) {
            var _this = this;

            if (index != null) {
                this.$nextTick(function () {
                    _this.scrollToCur();
                });
            }
        }
    },

    methods: {
        itemName: function itemName(v) {
            var nameKey = this.nameKey;

            return nameKey ? v[nameKey] : v;
        },
        isCur: function isCur(index) {
            return index === this.atwho.cur;
        },
        handleItemHover: function handleItemHover(e) {
            if (this.hoverSelect) {
                this.selectByMouse(e);
            }
        },
        handleItemClick: function handleItemClick(e) {
            this.selectByMouse(e);
            this.insertItem();
        },
        handleDelete: function handleDelete(e) {
            var range = Object(__WEBPACK_IMPORTED_MODULE_1__util__["e" /* getPrecedingRange */])();
            if (range) {
                var atItems = this.atItems,
                    members = this.members,
                    deleteMatch = this.deleteMatch,
                    itemName = this.itemName;

                var text = range.toString();

                var _getAtAndIndex = Object(__WEBPACK_IMPORTED_MODULE_1__util__["c" /* getAtAndIndex */])(text, atItems),
                    at = _getAtAndIndex.at,
                    index = _getAtAndIndex.index;

                if (index > -1) {
                    var chunk = text.slice(index + at.length, -1);
                    var has = members.some(function (v) {
                        var name = itemName(v);
                        return deleteMatch(name, chunk);
                    });
                    if (has) {
                        e.preventDefault();
                        e.stopPropagation();
                        var r = Object(__WEBPACK_IMPORTED_MODULE_1__util__["f" /* getRange */])();
                        if (r) {
                            r.setStart(r.endContainer, index);
                            r.deleteContents();
                            Object(__WEBPACK_IMPORTED_MODULE_1__util__["a" /* applyRange */])(r);
                        }
                    }
                }
            }
        },
        handleKeyDown: function handleKeyDown(e) {
            var atwho = this.atwho;

            if (atwho) {
                if (e.keyCode === 38 || e.keyCode === 40) {
                    if (!(e.metaKey || e.ctrlKey)) {
                        e.preventDefault();
                        e.stopPropagation();
                        this.selectByKeyboard(e);
                    }
                    return;
                }
                if (e.keyCode === 13) {
                    this.insertItem();
                    e.preventDefault();
                    e.stopPropagation();
                    return;
                }
                if (e.keyCode === 27) {
                    this.closePanel();
                    return;
                }
            }

            var isChar = e.keyCode >= 48 && e.keyCode <= 90;
            if (isChar) {
                setTimeout(this.handleInput, 50);
            }

            if (e.keyCode === 8) {
                this.handleDelete(e);
            }
        },
        handleCompositionStart: function handleCompositionStart() {
            this.hasComposition = true;
        },
        handleCompositionEnd: function handleCompositionEnd() {
            this.hasComposition = false;
            this.handleInput();
        },
        handleInput: function handleInput() {
            if (this.hasComposition) return;
            var range = Object(__WEBPACK_IMPORTED_MODULE_1__util__["e" /* getPrecedingRange */])();
            if (range) {
                var atItems = this.atItems,
                    avoidEmail = this.avoidEmail,
                    allowSpaces = this.allowSpaces;


                var show = true;
                var text = range.toString();

                var _getAtAndIndex2 = Object(__WEBPACK_IMPORTED_MODULE_1__util__["c" /* getAtAndIndex */])(text, atItems),
                    at = _getAtAndIndex2.at,
                    index = _getAtAndIndex2.index;

                if (index < 0) show = false;
                var prev = text[index - 1];

                var chunk = text.slice(index + 1, text.length);

                if (avoidEmail) {
                    if (/^[a-z0-9]$/i.test(prev)) show = false;
                }

                if (!allowSpaces && /\s/.test(chunk)) {
                    show = false;
                }

                if (/^\s/.test(chunk)) show = false;

                if (!show) {
                    this.closePanel();
                } else {
                    var members = this.members,
                        filterMatch = this.filterMatch,
                        itemName = this.itemName;

                    var matched = members.filter(function (v) {
                        var name = itemName(v);
                        return filterMatch(name, chunk, at);
                    });
                    if (matched.length) {
                        this.openPanel(matched, range, index, at);
                    } else {
                        this.closePanel();
                    }
                }
            }
        },
        closePanel: function closePanel() {
            if (this.atwho) {
                this.atwho = null;
            }
        },
        openPanel: function openPanel(list, range, offset, at) {
            var _this2 = this;

            var fn = function fn() {
                var r = range.cloneRange();
                r.setStart(r.endContainer, offset + at.length);
                var rect = r.getClientRects()[0];
                _this2.atwho = {
                    range: range,
                    offset: offset,
                    list: list,
                    x: rect.left,
                    y: rect.top - 4,
                    cur: 0 };
            };
            if (this.atwho) {
                fn();
            } else {
                setTimeout(fn, 10);
            }
        },
        scrollToCur: function scrollToCur() {
            var curEl = this.$refs.cur[0];
            var scrollParent = curEl.parentElement.parentElement;
            Object(__WEBPACK_IMPORTED_MODULE_1__util__["g" /* scrollIntoView */])(curEl, scrollParent);
        },
        selectByMouse: function selectByMouse(e) {
            var el = Object(__WEBPACK_IMPORTED_MODULE_1__util__["b" /* closest */])(e.target, function (d) {
                return d.dataset.index;
            });
            var cur = +el.dataset.index;
            this.atwho = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.atwho, {
                cur: cur
            });
        },
        selectByKeyboard: function selectByKeyboard(e) {
            var offset = e.keyCode === 38 ? -1 : 1;
            var atwho = this.atwho,
                members = this.members;
            var cur = atwho.cur;

            this.atwho = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.atwho, {
                cur: (cur + offset + members.length) % members.length
            });
        },
        insertItem: function insertItem() {
            var _atwho2 = this.atwho,
                range = _atwho2.range,
                list = _atwho2.list,
                cur = _atwho2.cur;
            var atItems = this.atItems,
                itemName = this.itemName;

            var r = range.cloneRange();
            var text = range.toString();

            var _getAtAndIndex3 = Object(__WEBPACK_IMPORTED_MODULE_1__util__["c" /* getAtAndIndex */])(text, atItems),
                at = _getAtAndIndex3.at,
                index = _getAtAndIndex3.index;

            r.setStart(r.endContainer, index + at.length);
            Object(__WEBPACK_IMPORTED_MODULE_1__util__["a" /* applyRange */])(r);
            Object(__WEBPACK_IMPORTED_MODULE_1__util__["a" /* applyRange */])(r);
            document.execCommand('insertText', 0, itemName(list[cur]) + ' ');
        }
    }
});

/***/ }),

/***/ 236:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"wrap",staticClass:"atwho-wrap",on:{"compositionstart":_vm.handleCompositionStart,"compositionend":_vm.handleCompositionEnd,"input":_vm.handleInput,"keydown":_vm.handleKeyDown}},[(_vm.atwho)?_c('div',{staticClass:"atwho-panel",style:(_vm.style)},[_c('div',{staticClass:"atwho-inner"},[_c('div',{staticClass:"atwho-view"},[_c('ul',{staticClass:"atwho-ul"},_vm._l((_vm.atwho.list),function(item,index){return _c('li',{ref:_vm.isCur(index) && 'cur',refInFor:true,staticClass:"atwho-li",class:_vm.isCur(index) && 'atwho-cur',attrs:{"data-index":index},on:{"mouseenter":_vm.handleItemHover,"click":_vm.handleItemClick}},[_vm._t("item",[_c('span',{domProps:{"textContent":_vm._s(_vm.itemName(item))}})],{item:item})],2)}))])])]):_vm._e(),_vm._v(" "),_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 237:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Task_vue__ = __webpack_require__(239);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3a19d3be_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Task_vue__ = __webpack_require__(240);
function injectStyle (ssrContext) {
  __webpack_require__(238)
}
var normalizeComponent = __webpack_require__(10)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Task_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3a19d3be_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Task_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 238:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 239:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_helper__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_marked__ = __webpack_require__(152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_marked___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_marked__);








__WEBPACK_IMPORTED_MODULE_4_marked___default.a.setOptions({
    sanitize: true,
    gfm: true,
    breaks: true
});

/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'Task',
    props: {
        task: {
            type: Object,
            required: true
        },
        workarea: {
            type: Object,
            required: false
        },
        index: {
            type: Number,
            required: false
        }
    },
    data: function data() {
        return {};
    },

    computed: {
        favorites: function favorites() {
            return this.$store.state.favorites.favorites;
        },
        currentWorkarea: function currentWorkarea() {
            if (this.workarea !== undefined && this.workarea !== null) {
                return this.workarea;
            } else {
                return 'Ingen';
            }
        },
        isSent: function isSent() {
            return __WEBPACK_IMPORTED_MODULE_2__utils_helper__["a" /* default */].task.isSent(this.task, this.$store.state.authentication.user, this.currentWorkarea);
        },
        isReceived: function isReceived() {
            return __WEBPACK_IMPORTED_MODULE_2__utils_helper__["a" /* default */].task.isReceived(this.task, this.$store.state.authentication.user, this.currentWorkarea);
        },
        createdTime: function createdTime() {
            return __WEBPACK_IMPORTED_MODULE_2__utils_helper__["a" /* default */].task.getCreatedTime(this.task);
        },
        updatedTime: function updatedTime() {
            return __WEBPACK_IMPORTED_MODULE_2__utils_helper__["a" /* default */].task.getUpdatedTime(this.task);
        },
        createdTimeFull: function createdTimeFull() {
            return __WEBPACK_IMPORTED_MODULE_2__utils_helper__["a" /* default */].task.getCreatedTimeFull(this.task);
        },
        updatedTimeFull: function updatedTimeFull() {
            return __WEBPACK_IMPORTED_MODULE_2__utils_helper__["a" /* default */].task.getUpdatedTimeFull(this.task);
        },
        deadline: function deadline() {
            return __WEBPACK_IMPORTED_MODULE_2__utils_helper__["a" /* default */].task.formatTime(this.task.deadline);
        },
        deadlineFull: function deadlineFull() {
            return __WEBPACK_IMPORTED_MODULE_2__utils_helper__["a" /* default */].task.formatTimeFull(this.task.deadline);
        },
        creator: function creator() {
            return __WEBPACK_IMPORTED_MODULE_2__utils_helper__["a" /* default */].task.getCreator(this.task);
        },
        status: function status() {
            return this.task.status;
        },
        statusString: function statusString() {
            return __WEBPACK_IMPORTED_MODULE_2__utils_helper__["a" /* default */].status.toString(this.status);
        },
        sharedStatus: function sharedStatus() {
            var _this = this;

            var status = 10;
            var highest = 0;

            if (this.task.creator !== this.$store.state.authentication.user.id) {
                var user = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.find(this.task.users, { user: this.$store.state.authentication.user.id });

                if (user !== undefined && user !== null) {
                    return __WEBPACK_IMPORTED_MODULE_2__utils_helper__["a" /* default */].sharedStatus.toString(user.shared_status);
                }
            }

            __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.each(this.task.users, function (user) {
                if (user.shared_status < status && user.user !== _this.task.creator && user.shared_status !== _this.task.shared_status) {
                    status = user.shared_status;
                }

                if (user.shared_status > highest && user.user !== _this.task.creator && user.shared_status !== _this.task.shared_status) {
                    highest = user.shared_status;
                }
            });

            if (status === 5 && highest > status && highest < 8) {
                status = highest;
            }

            if (status === 10) {
                status = this.task.shared_status;
            }

            return __WEBPACK_IMPORTED_MODULE_2__utils_helper__["a" /* default */].sharedStatus.toString(status);
        },
        isFavorited: function isFavorited() {
            return __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.includes(this.favorites, this.task.id);
        },
        isCreator: function isCreator() {
            return this.$store.state.authentication.user.id === this.task.creator;
        },
        isMember: function isMember() {
            return __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.find(this.task.users, { user: this.$store.state.authentication.user.id }) !== undefined;
        },
        isWorkarea: function isWorkarea() {
            return __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.find(this.$store.state.workarea.workareas, { id: this.task.workarea }) !== undefined;
        },
        isShared: function isShared() {
            return this.task.users.length > 1;
        },
        isWorkspaceReceived: function isWorkspaceReceived() {
            var workspace = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.find(this.$store.state.workarea.workareas, { id: this.task.workarea });

            if (workspace !== null && workspace !== undefined && this.task.users.length > 1) {
                return __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.find(workspace.members, { id: this.task.creator }) === undefined;
            }

            return false;
        },
        showSharedDropdown: function showSharedDropdown() {
            return (this.isShared && this.isMember && !this.isCreator || this.isWorkspaceReceived) && this.canAccept;
        },
        showSharedStatus: function showSharedStatus() {
            return this.isShared && (this.isCreator || this.isWorkarea) && !this.isWorkspaceReceived;
        },
        showStatusDropdown: function showStatusDropdown() {
            return (this.isCreator || this.isWorkarea) && !this.isWorkspaceReceived;
        },
        showSharedStatusDropdown: function showSharedStatusDropdown() {
            return (this.isShared && this.isMember && !this.isCreator || this.isWorkspaceReceived) && !this.canAccept;
        },
        showStatusInformation: function showStatusInformation() {
            return !this.isCreator && !this.isMember && !this.isWorkarea;
        },
        showRemove: function showRemove() {
            return (this.isCreator || this.isWorkarea) && this.creatorIsWorkspaceMember;
        },
        creatorIsWorkspaceMember: function creatorIsWorkspaceMember() {
            var workspace = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.find(this.$store.state.workarea.workareas, { id: this.task.workarea });

            if (workspace !== null && workspace !== undefined && this.task.users.length > 1) {
                return __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.find(workspace.members, { id: this.task.creator }) !== undefined;
            }

            return true;
        },
        unreadMessages: function unreadMessages() {
            var _this2 = this;

            if (this.task.messages) {
                var user = this.$store.state.authentication.user;
                var workareas = this.$store.state.workarea.workareas;
                return __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.filter(this.task.messages, function (message) {
                    return (message.acknowledged_by === null || message.acknowledged_by === undefined) && __WEBPACK_IMPORTED_MODULE_2__utils_helper__["a" /* default */].task.isIncommingMessage(_this2.task, user, message, workareas);
                }).length;
            } else {
                return 0;
            }
        },
        unreadMessagesOutgoing: function unreadMessagesOutgoing() {
            var _this3 = this;

            if (this.task.messages) {
                var user = this.$store.state.authentication.user;
                var workareas = this.$store.state.workarea.workareas;
                return __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.filter(this.task.messages, function (message) {
                    return (message.acknowledged_by === null || message.acknowledged_by === undefined) && !__WEBPACK_IMPORTED_MODULE_2__utils_helper__["a" /* default */].task.isIncommingMessage(_this3.task, user, message, workareas);
                }).length;
            } else {
                return 0;
            }
        },
        canAccept: function canAccept() {
            var _this4 = this;

            if (this.task.workarea !== null && this.task.workarea !== undefined) {
                var workarea = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.find(this.$store.state.workarea.workareas, { id: this.task.workarea });
                var user = void 0;

                if (!workarea) {
                    console.log('COULD NOT FIND WORKAREA', this.task.workarea, this.task);
                }

                __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.each(workarea.members, function (member) {
                    if (user === undefined || user === null) {
                        user = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.find(_this4.task.users, { user: member.id });
                    }
                });

                if (user !== undefined && user !== null) {
                    return user.shared_status < 4;
                }
            }

            if (this.task.shared_status < 4) {
                return true;
            }

            return false;
        },
        getWorkarea: function getWorkarea() {
            var workspace = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.find(this.$store.state.workarea.workareas, { id: this.task.workarea });

            if (workspace !== null && workspace !== undefined) {
                return workspace.name;
            }

            return '';
        }
    },
    methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])({
        setStatusStore: 'task_status',
        setSharedStatusStore: 'task_shared_status',
        addFavorite: 'favorites_insert',
        delFavorite: 'favorites_remove'
    }), {
        setStatus: function setStatus(status) {
            this.setStatusStore({ task: this.task, status: status });
        },
        setSharedStatus: function setSharedStatus(status) {
            if (status === 6) {
                this.setStatusStore({ task: this.task, status: 6 });
            }

            if (status === 7 || status === 5) {
                this.setStatusStore({ task: this.task, status: 2 });
            }

            this.setSharedStatusStore({ task: this.task, status: status });
        },
        getStatus: function getStatus() {
            return __WEBPACK_IMPORTED_MODULE_2__utils_helper__["a" /* default */].status.toString(this.status);
        },
        toggleFavorited: function toggleFavorited() {
            if (this.isFavorited) {
                this.delFavorite(this.task);
            } else {
                this.addFavorite(this.task);
            }
        },
        marked: function marked(content) {
            return __WEBPACK_IMPORTED_MODULE_4_marked___default()(content);
        }
    })
});

/***/ }),

/***/ 240:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',{staticClass:"w-100",class:{ sent: _vm.isSent, received: !_vm.isSent && _vm.isReceived },attrs:{"show-header":"","show-footer":""}},[_c('div',{staticClass:"row text-muted",attrs:{"slot":"footer"},slot:"footer"},[_c('div',{staticClass:"col footer"},[_c('span',[_vm._v("Skapades\n                    "),_c('span',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip"}],staticClass:"datetime",attrs:{"title":_vm.createdTimeFull}},[_vm._v(_vm._s(_vm.createdTime))]),_vm._v(" "),(_vm.updatedTime !== 'Aldrig')?_c('span',[(_vm.deadline === 'Aldrig')?_c('span',[_vm._v("och ")]):_c('span',[_vm._v(", ")]),_vm._v("uppdaterades\n                        "),_c('span',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip"}],staticClass:"datetime",attrs:{"title":_vm.updatedTimeFull}},[_vm._v(_vm._s(_vm.updatedTime))])]):_vm._e(),_vm._v(" "),(_vm.deadline !== 'Aldrig')?_c('span',[_vm._v("\n                        och förfaller\n                        "),_c('span',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip"}],staticClass:"datetime",attrs:{"title":_vm.deadlineFull}},[_vm._v(_vm._s(_vm.deadline))])]):_vm._e()])])]),_vm._v(" "),_c('div',{staticClass:"row",attrs:{"slot":"header"},slot:"header"},[_c('div',{staticClass:"col-sm"},[_c('b-nav',{staticClass:"task-header",attrs:{"pills":""}},[_c('b-nav-item',[_vm._v("@"+_vm._s(this.creator.username))]),_vm._v(" "),(_vm.showStatusDropdown)?_c('b-nav-item-dropdown',{attrs:{"text":_vm.statusString,"size":"sm"}},[_c('b-dropdown-item',{on:{"click":function($event){_vm.setStatus(1)}}},[_vm._v("Öppen")]),_vm._v(" "),_c('b-dropdown-item',{on:{"click":function($event){_vm.setStatus(6)}}},[_vm._v("Klar")]),_vm._v(" "),_c('b-dropdown-item',{on:{"click":function($event){_vm.setStatus(3)}}},[_vm._v("Planerad")]),_vm._v(" "),_c('b-dropdown-item',{on:{"click":function($event){_vm.setStatus(4)}}},[_vm._v("Pågående")]),_vm._v(" "),_c('b-dropdown-item',{on:{"click":function($event){_vm.setStatus(5)}}},[_vm._v("Avvakta")]),_vm._v(" "),_c('b-dropdown-item',{on:{"click":function($event){_vm.setStatus(2)}}},[_vm._v("Avslutad")])],1):_vm._e(),_vm._v(" "),(_vm.showStatusInformation)?_c('b-nav-item',[_vm._v(_vm._s(_vm.status))]):_vm._e(),_vm._v(" "),(_vm.showSharedStatusDropdown)?_c('b-nav-item-dropdown',{attrs:{"text":_vm.sharedStatus,"size":"sm"}},[_c('b-dropdown-item',{on:{"click":function($event){_vm.setSharedStatus(6)}}},[_vm._v("Klar")])],1):_vm._e(),_vm._v(" "),(_vm.showSharedDropdown)?_c('b-nav-item-dropdown',{attrs:{"text":_vm.sharedStatus,"size":"sm"}},[_c('b-dropdown-item',{on:{"click":function($event){_vm.setSharedStatus(4)}}},[_vm._v("Acceptera")]),_vm._v(" "),_c('b-dropdown-item',{on:{"click":function($event){_vm.setSharedStatus(5)}}},[_vm._v("Neka")])],1):_vm._e(),_vm._v(" "),(_vm.showSharedStatus && !_vm.showSharedDropdown && !_vm.showSharedStatusDropdown)?_c('b-nav-item',[_vm._v(_vm._s(_vm.sharedStatus))]):_vm._e(),_vm._v(" "),(_vm.getWorkarea !== '')?_c('b-nav-item',{staticClass:"workname align-items-center",attrs:{"size":"sm"}},[_vm._v(_vm._s(_vm.getWorkarea))]):_c('b-nav-item',{staticClass:"workname",attrs:{"size":"sm"}},[_vm._v("Ingen")]),_vm._v(" "),(_vm.unreadMessages > 0)?_c('b-nav-item',{staticClass:"unread ml-auto"},[_c('b-badge',{attrs:{"pill":"","variant":"danger"}},[_vm._v(_vm._s(_vm.unreadMessages))])],1):_vm._e(),_vm._v(" "),(_vm.unreadMessagesOutgoing > 0)?_c('b-nav-item',{staticClass:"unread-recv ml-auto"},[_c('b-badge',{attrs:{"pill":"","variant":"primary"}},[_vm._v(_vm._s(_vm.unreadMessagesOutgoing))])],1):_vm._e(),_vm._v(" "),_c('b-nav-item',{class:{'ml-auto': (_vm.unreadMessages === 0 && _vm.unreadMessagesOutgoing === 0)},attrs:{"size":"sm"}},[_c('b-button',{attrs:{"variant":"success","size":"sm"},on:{"click":function($event){_vm.$emit('send')}}},[_c('i',{staticClass:"material-icons icon"},[_vm._v("")])])],1),_vm._v(" "),_c('b-nav-item',{attrs:{"size":"sm"}},[_c('b-button',{staticClass:"favorite",class:{favorited: _vm.isFavorited},attrs:{"size":"sm"},on:{"click":function($event){_vm.toggleFavorited()}}},[(_vm.isFavorited)?_c('i',{staticClass:"material-icons icon"},[_vm._v("")]):_c('i',{staticClass:"material-icons icon"},[_vm._v("")])])],1),_vm._v(" "),(_vm.showRemove)?_c('b-nav-item',{attrs:{"size":"sm"}},[_c('b-button',{attrs:{"variant":"danger","size":"sm"},on:{"click":function($event){_vm.$emit('remove')}}},[_c('i',{staticClass:"material-icons icon"},[_vm._v("")])])],1):_vm._e()],1)],1)]),_vm._v(" "),_c('router-link',{attrs:{"active-class":"active","to":{ name: 'Task', params: { id: _vm.task.id } },"exact":""}},[_c('a',{domProps:{"innerHTML":_vm._s(_vm.task.content_parsed)}})])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 241:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tasks row justify-content-center"},[_c('b-modal',{ref:"removeConfirmation",attrs:{"id":"removeConfirmation","title":"Ta bort uppgift","close-title":"Nej","ok-title":"Ja"},on:{"ok":_vm.removeAction,"cancel":_vm.removeCancel}},[_c('span',[_vm._v("Vill du ta bort uppgiften?")])]),_vm._v(" "),_c('b-modal',{ref:"createTask",attrs:{"id":"createTask","title":"Ny uppgift"},on:{"hidden":_vm.resetEditor}},[_c('div',{staticClass:"row fill justify-left",attrs:{"slot":"modal-footer"},slot:"modal-footer"},[_c('div',{staticClass:"col-sm-6 justify-left"},[_c('b-form-fieldset',{attrs:{"label":"Max","horizontal":""}},[_c('b-form-input',{attrs:{"type":"number"},model:{value:(_vm.maxRecv),callback:function ($$v) {_vm.maxRecv=$$v},expression:"maxRecv"}})],1)],1),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"float-right"},[_c('b-button',{on:{"click":_vm.resetEditor}},[_vm._v("Avbryt")]),_vm._v(" "),_c('b-button',{attrs:{"variant":"primary"},on:{"click":_vm.create}},[_vm._v("Skapa")])],1)])]),_vm._v(" "),_c('at-textarea',{attrs:{"members":_vm.getAutocompleteList(),"avoid-emails":true}},[_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.content),expression:"content"}],staticClass:"editorMain",attrs:{"id":"markdownEditor"},domProps:{"value":(_vm.content)},on:{"input":function($event){if($event.target.composing){ return; }_vm.content=$event.target.value}}})]),_vm._v(" "),(!this.deadline)?_c('button',{staticClass:"btn btn-md btn-outline-success btn-block",attrs:{"type":"submit"},on:{"click":_vm.setDeadline}},[_vm._v("Förfaller")]):_c('Datetime',{staticClass:"form-control",attrs:{"type":"datetime","monday-first":"","auto-continue":""},model:{value:(_vm.deadline),callback:function ($$v) {_vm.deadline=$$v},expression:"deadline"}})],1),_vm._v(" "),_c('div',{staticClass:"col-sm-9"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-2"},[_c('b-button',{directives:[{name:"b-modal",rawName:"v-b-modal.createTask",modifiers:{"createTask":true}}],attrs:{"size":"lg","variant":"success"}},[_vm._v("Skapa")])],1),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('div',{staticClass:"col-sm-4"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.selected),expression:"selected"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.selected=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"Ingen"}},[_vm._v("Alla")]),_vm._v(" "),_vm._l((_vm.workareas),function(workarea){return _c('option',{domProps:{"value":workarea}},[_vm._v("\n                      "+_vm._s(workarea.name)+"\n                  ")])})],2)]),_vm._v(" "),_c('div',{staticClass:"col-sm-4"},[_c('div',{staticClass:"input-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchinter),expression:"searchinter"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Sök"},domProps:{"value":(_vm.searchinter)},on:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key)){ return null; }_vm.setSearchString()},"input":function($event){if($event.target.composing){ return; }_vm.searchinter=$event.target.value}}}),_vm._v(" "),_c('span',{staticClass:"input-group-btn"},[_c('button',{staticClass:"btn btn-secondary",on:{"click":function($event){_vm.setSearchString()}}},[_c('i',{staticClass:"material-icons icon"},[_vm._v("")])])])])])]),_vm._v(" "),_vm._l((_vm.tasks),function(task,index){return _c('div',{staticClass:"row task-row w-80"},[_c('Task',{attrs:{"task":task,"index":index,"workarea":_vm.workarea},on:{"remove":function($event){_vm.setRemoveTask({task: task, index: index})},"send":function($event){_vm.sendTask(task)}}})],1)})],2),_vm._v(" "),_c('div',{staticClass:"col-sm-3"},[_c('div',{staticClass:"filter-row"},[_c('span',[_vm._v("Visar nu "),_c('b',[_vm._v(_vm._s(_vm.tasks !== null ? _vm.tasks.length : 0))]),_vm._v(" uppgifter")])]),_vm._v(" "),_c('div',{staticClass:"filter-row"},[_c('h5',[_vm._v("Delade")]),_vm._v(" "),_c('b-form-select',{attrs:{"options":_vm.sharedOptions},model:{value:(_vm.shared),callback:function ($$v) {_vm.shared=$$v},expression:"shared"}})],1),_vm._v(" "),_c('div',{staticClass:"filter-row"},[_c('h5',[_vm._v("Förfallna")]),_vm._v(" "),_c('b-form-select',{attrs:{"options":_vm.deadlineOptions,"stacked":true},model:{value:(_vm.deadlineShow),callback:function ($$v) {_vm.deadlineShow=$$v},expression:"deadlineShow"}})],1),_vm._v(" "),_c('div',{staticClass:"filter-row"},[_c('h5',[_vm._v("Ordning")]),_vm._v(" "),_c('b-button-group',[_c('b-button',{attrs:{"variant":_vm.orderKey === 'created_at' ? 'success' : 'secondary'},on:{"click":function($event){_vm.reverseOrder('created_at')}}},[_vm._v("Skapad "),(_vm.order === 'desc' && _vm.orderKey === 'created_at')?_c('i',{staticClass:"material-icons icon align"},[_vm._v("")]):_vm._e(),(_vm.order === 'asc' && _vm.orderKey === 'created_at')?_c('i',{staticClass:"material-icons icon align"},[_vm._v("")]):_vm._e()]),_vm._v(" "),_c('b-button',{attrs:{"variant":_vm.orderKey === 'updated_at' ? 'success' : 'secondary'},on:{"click":function($event){_vm.reverseOrder('updated_at')}}},[_vm._v("Uppdaterad "),(_vm.order === 'desc' && _vm.orderKey === 'updated_at')?_c('i',{staticClass:"material-icons icon align"},[_vm._v("")]):_vm._e(),(_vm.order === 'asc' && _vm.orderKey === 'updated_at')?_c('i',{staticClass:"material-icons icon align"},[_vm._v("")]):_vm._e()]),_vm._v(" "),_c('b-button',{attrs:{"variant":_vm.orderKey === 'deadline' ? 'success' : 'secondary'},on:{"click":function($event){_vm.reverseOrder('deadline')}}},[_vm._v("Förfaller "),(_vm.order === 'desc' && _vm.orderKey === 'deadline')?_c('i',{staticClass:"material-icons icon align"},[_vm._v("")]):_vm._e(),(_vm.order === 'asc' && _vm.orderKey === 'deadline')?_c('i',{staticClass:"material-icons icon align"},[_vm._v("")]):_vm._e()])],1)],1),_vm._v(" "),_c('div',{staticClass:"filter-row"},[_c('h5',[_vm._v("Filter")]),_vm._v(" "),_c('table',{staticClass:"table table-bordered table-striped"},[_vm._m(1),_vm._v(" "),_c('tbody',[_c('tr',[_c('td',[_vm._v("Öppen")]),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.statuses),expression:"statuses"}],attrs:{"type":"checkbox","value":"1"},domProps:{"checked":Array.isArray(_vm.statuses)?_vm._i(_vm.statuses,"1")>-1:(_vm.statuses)},on:{"change":[function($event){var $$a=_vm.statuses,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="1",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.statuses=$$a.concat([$$v]))}else{$$i>-1&&(_vm.statuses=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.statuses=$$c}},_vm.filter]}})])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("Avslutad")]),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.statuses),expression:"statuses"}],attrs:{"type":"checkbox","value":"2"},domProps:{"checked":Array.isArray(_vm.statuses)?_vm._i(_vm.statuses,"2")>-1:(_vm.statuses)},on:{"change":[function($event){var $$a=_vm.statuses,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="2",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.statuses=$$a.concat([$$v]))}else{$$i>-1&&(_vm.statuses=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.statuses=$$c}},_vm.filter]}})])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("Planerad")]),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.statuses),expression:"statuses"}],attrs:{"type":"checkbox","value":"3"},domProps:{"checked":Array.isArray(_vm.statuses)?_vm._i(_vm.statuses,"3")>-1:(_vm.statuses)},on:{"change":[function($event){var $$a=_vm.statuses,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="3",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.statuses=$$a.concat([$$v]))}else{$$i>-1&&(_vm.statuses=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.statuses=$$c}},_vm.filter]}})])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("Pågående")]),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.statuses),expression:"statuses"}],attrs:{"type":"checkbox","value":"4"},domProps:{"checked":Array.isArray(_vm.statuses)?_vm._i(_vm.statuses,"4")>-1:(_vm.statuses)},on:{"change":[function($event){var $$a=_vm.statuses,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="4",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.statuses=$$a.concat([$$v]))}else{$$i>-1&&(_vm.statuses=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.statuses=$$c}},_vm.filter]}})])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("Avvakta")]),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.statuses),expression:"statuses"}],attrs:{"type":"checkbox","value":"5"},domProps:{"checked":Array.isArray(_vm.statuses)?_vm._i(_vm.statuses,"5")>-1:(_vm.statuses)},on:{"change":[function($event){var $$a=_vm.statuses,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="5",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.statuses=$$a.concat([$$v]))}else{$$i>-1&&(_vm.statuses=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.statuses=$$c}},_vm.filter]}})])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("Klar")]),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.statuses),expression:"statuses"}],attrs:{"type":"checkbox","value":"6"},domProps:{"checked":Array.isArray(_vm.statuses)?_vm._i(_vm.statuses,"6")>-1:(_vm.statuses)},on:{"change":[function($event){var $$a=_vm.statuses,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="6",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.statuses=$$a.concat([$$v]))}else{$$i>-1&&(_vm.statuses=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.statuses=$$c}},_vm.filter]}})])])])])]),_vm._v(" "),_c('div',{staticClass:"filter-row"},[_c('button',{staticClass:"btn btn-md btn-warning btn-block",on:{"click":function($event){_vm.selectFilter({tag: null, category: null})}}},[_vm._v("Rensa filter")]),_vm._v(" "),_c('ul',{staticClass:"filter filter-first"},_vm._l((_vm.filterList['']),function(tag){return _c('li',[_c('a',{attrs:{"href":"#"},on:{"click":function($event){_vm.selectFilter({tag: tag, category: null})}}},[_vm._v("#"+_vm._s(tag))])])})),_vm._v(" "),_c('ul',{staticClass:"filter"},_vm._l((_vm.filterList),function(tags,category){return (category !== '')?_c('li',[_c('a',{attrs:{"href":"#"},on:{"click":function($event){_vm.selectFilter({tag: null, category: category})}}},[_vm._v("+"+_vm._s(category))]),_vm._v(" "),(tags.length > 0)?_c('ul',{staticClass:"subfilter"},_vm._l((tags),function(tag){return _c('li',[_c('a',{attrs:{"href":"#"},on:{"click":function($event){_vm.selectFilter({tag: tag, category: category})}}},[_vm._v("#"+_vm._s(tag))])])})):_vm._e()]):_vm._e()}))])])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-sm-2 prefix"},[_c('span',[_vm._v("Arbetsyta:")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',[_vm._v("Status")]),_vm._v(" "),_c('th',[_vm._v("Visa")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 242:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__ = __webpack_require__(244);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_226cc518_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__ = __webpack_require__(247);
function injectStyle (ssrContext) {
  __webpack_require__(243)
}
var normalizeComponent = __webpack_require__(10)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-226cc518"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_226cc518_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 243:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 244:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__router__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_timeout__ = __webpack_require__(153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__bugsnag__ = __webpack_require__(29);








/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'Login',
    data: function data() {
        return {
            username: '',
            password: '',
            showDismissableAlert: false,
            alertContents: 'Fel användarnamn eller lösenord'
        };
    },

    methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])({
        login: 'auth_login',
        loadFriends: 'friend_list',
        loadGroups: 'group_list',
        loadWorkarea: 'workarea_list',
        loadTasks: 'task_list'
    }), {
        refresh: function refresh() {
            if (this.$store.state.task.syncing !== true) {
                this.loadTasks({ offset: 0 });
            }
        },
        submit: function submit() {
            var _this = this;

            this.$validator.validateAll().then(function () {
                _this.login({ username: _this.username, password: _this.password }).then(function () {
                    _this.loadFriends();

                    _this.loadGroups();

                    _this.loadWorkarea();

                    __WEBPACK_IMPORTED_MODULE_4__utils_timeout__["a" /* default */].startTimedFunction(_this.refresh, 1000 * 30 * 1);

                    __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */].push('/');
                }).catch(function (error) {
                    __WEBPACK_IMPORTED_MODULE_5__bugsnag__["a" /* default */].notify(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(error));

                    if (error.status === 401) {
                        _this.alertContents = 'Fel användarnamn eller lösenord';
                    } else {
                        _this.alertContents = 'Något gick fel vid inloggning. Försök igen senare.';
                    }

                    _this.showDismissableAlert = true;
                });
            });
        }
    })
});

/***/ }),

/***/ 247:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"login row justify-content-center"},[_c('div',{staticClass:"col-md-6"},[_c('b-alert',{attrs:{"variant":"danger","dismissible":"","show":_vm.showDismissableAlert},on:{"dismissed":function($event){_vm.showDismissableAlert=false}}},[_vm._v("\n          "+_vm._s(_vm.alertContents)+"\n      ")]),_vm._v(" "),_c('form',{on:{"submit":function($event){$event.preventDefault();_vm.submit($event)}}},[_c('b-form-fieldset',{attrs:{"label":"Användarnamn","state":_vm.errors.has('username') ? 'danger' : 'success',"horizontal":true,"label-size":3}},[_c('b-form-input',{directives:[{name:"validate",rawName:"v-validate:username.initial",value:('required|alpha_num|min:2'),expression:"'required|alpha_num|min:2'",arg:"username",modifiers:{"initial":true}}],attrs:{"name":"username","placeholder":"Användarnamn"},model:{value:(_vm.username),callback:function ($$v) {_vm.username=$$v},expression:"username"}})],1),_vm._v(" "),_c('b-form-fieldset',{attrs:{"label":"Lösenord","state":_vm.errors.has('password') ? 'danger' : 'success',"horizontal":true,"label-size":3}},[_c('b-form-input',{directives:[{name:"validate",rawName:"v-validate:password.initial",value:('required|min:6'),expression:"'required|min:6'",arg:"password",modifiers:{"initial":true}}],attrs:{"type":"password","name":"password","placeholder":"Lösenord"},model:{value:(_vm.password),callback:function ($$v) {_vm.password=$$v},expression:"password"}})],1),_vm._v(" "),_c('b-button',{attrs:{"block":true,"variant":"primary","size":"lg","type":"submit"}},[_vm._v("Logga in")])],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 248:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Friends_vue__ = __webpack_require__(250);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_15f82bdc_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Friends_vue__ = __webpack_require__(251);
function injectStyle (ssrContext) {
  __webpack_require__(249)
}
var normalizeComponent = __webpack_require__(10)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Friends_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_15f82bdc_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Friends_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 249:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 250:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(13);





/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'friends',
    computed: {
        friends: function friends() {
            return this.$store.state.friend.friends;
        }
    },
    data: function data() {
        return {
            username: '',
            friend: null
        };
    },
    mounted: function mounted() {
        this.refresh();
    },

    methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])({
        refresh: 'friend_list',
        create: 'friend_post',
        accept: 'friend_put',
        remove: 'friend_delete'
    }), {
        selectForRemoval: function selectForRemoval(_ref) {
            var friend = _ref.friend,
                index = _ref.index;

            this.friend = { friend: friend, index: index };
            this.$refs.removeConfirmation.show();
        },
        removeAction: function removeAction() {
            this.remove(this.friend);
        },
        removeCancel: function removeCancel() {
            this.friend = null;
        },
        sendFriendRequest: function sendFriendRequest() {
            this.create(this.username);
            this.username = '';
        }
    })
});

/***/ }),

/***/ 251:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"friends row justify-content-center"},[_c('b-modal',{ref:"removeConfirmation",attrs:{"id":"removeConfirmation","title":"Ta bort vän","close-title":"Nej","ok-title":"Ja"},on:{"ok":_vm.removeAction,"cancel":_vm.removeCancel}},[_c('span',[_vm._v("Vill du ta bort din vän?")])]),_vm._v(" "),_c('div',{staticClass:"col-md-8"},[_c('div',{staticClass:"row"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"col-sm"},[_c('div',{staticClass:"input-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.username),expression:"username"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Användarnamn","required":"","autofocus":""},domProps:{"value":(_vm.username)},on:{"input":function($event){if($event.target.composing){ return; }_vm.username=$event.target.value}}}),_vm._v(" "),_c('span',{staticClass:"input-group-btn"},[_c('button',{staticClass:"btn btn-md btn-primary",attrs:{"type":"button"},on:{"click":function($event){_vm.create(_vm.username)}}},[_vm._v("Skicka")])])])])]),_vm._v(" "),_c('table',{staticClass:"table table-bordered table-striped"},[_vm._m(1),_vm._v(" "),_c('tbody',_vm._l((_vm.friends),function(friend,index){return _c('tr',[_c('td',[_vm._v(_vm._s(friend.username))]),_vm._v(" "),_c('td',[(friend.accepted)?_c('button',{staticClass:"btn btn-primary",on:{"click":function($event){_vm.selectForRemoval({friend: friend, index: index})}}},[_vm._v("Ta bort")]):_vm._e(),_vm._v(" "),(!friend.accepted)?_c('button',{staticClass:"btn btn-primary",on:{"click":function($event){_vm.accept(friend)}}},[_vm._v("Acceptera")]):_vm._e(),_vm._v(" "),(!friend.accepted)?_c('button',{staticClass:"btn btn-primary",on:{"click":function($event){_vm.remove({friend: friend, index: index})}}},[_vm._v("Neka")]):_vm._e()])])}))])])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-sm-7"},[_c('h2',[_vm._v("Vänner")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',[_vm._v("Användarnamn")]),_vm._v(" "),_c('th',[_vm._v("Hantera")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 252:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Groups_vue__ = __webpack_require__(253);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_247a5c14_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Groups_vue__ = __webpack_require__(254);
var normalizeComponent = __webpack_require__(10)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Groups_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_247a5c14_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Groups_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 253:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(13);





/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'groups',
    computed: {
        groups: function groups() {
            return this.$store.state.group.groups;
        },
        workareas: function workareas() {
            return this.$store.state.workarea.workareas;
        }
    },
    data: function data() {
        return {
            name: '',
            group: null
        };
    },
    mounted: function mounted() {
        this.name = '';
        this.refresh();
    },

    methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])({
        refresh: 'group_list',
        remove: 'group_delete',
        insert: 'group_post',
        select: 'group_select',
        update: 'group_put'
    }), {
        create: function create() {
            if (this.name === '' || this.name === undefined) {
                return;
            }

            this.insert(this.name);
        },
        selectForRemoval: function selectForRemoval(_ref) {
            var group = _ref.group,
                index = _ref.index;

            this.group = { group: group, index: index };
            this.$refs.removeConfirmation.show();
        },
        removeAction: function removeAction() {
            this.remove(this.group);
        },
        removeCancel: function removeCancel() {
            this.group = null;
        },
        updateWorkarea: function updateWorkarea(value, group) {
            if (value !== group.workarea) {
                console.log('UPDATE: ', value, group.workarea, group.name);
                this.update({ group: group, workarea: value });
            }
        }
    })
});

/***/ }),

/***/ 254:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"friends row justify-content-center"},[_c('b-modal',{ref:"removeConfirmation",attrs:{"id":"removeConfirmation","title":"Ta bort grupp","close-title":"Nej","ok-title":"Ja"},on:{"ok":_vm.removeAction,"cancel":_vm.removeCancel}},[_c('span',[_vm._v("Vill du ta bort din grupp?")])]),_vm._v(" "),_c('div',{staticClass:"col-md-8"},[_c('div',{staticClass:"row"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"col-sm"},[_c('div',{staticClass:"input-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.name),expression:"name"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Namn","required":"","autofocus":""},domProps:{"value":(_vm.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.name=$event.target.value}}}),_vm._v(" "),_c('span',{staticClass:"input-group-btn"},[_c('button',{staticClass:"btn btn-md btn-primary",attrs:{"type":"button"},on:{"click":function($event){_vm.create()}}},[_vm._v("Lägg till")])])])])]),_vm._v(" "),_c('table',{staticClass:"table table-bordered table-striped group-table"},[_vm._m(1),_vm._v(" "),_c('tbody',_vm._l((_vm.groups),function(group,index){return _c('tr',[_c('router-link',{attrs:{"tag":"td","active-class":"active","to":'/group/' + group.id,"exact":""},nativeOn:{"click":function($event){_vm.select({group: group, index: index})}}},[_c('a',[_vm._v(_vm._s(group.name))])]),_vm._v(" "),_c('td',[_c('button',{staticClass:"btn btn-primary",on:{"click":function($event){_vm.selectForRemoval({group: group, index: index})}}},[_vm._v("Ta bort")])]),_vm._v(" "),_c('td',[_c('b-form-select',{staticClass:"mb-3",attrs:{"text-field":"name","value-field":"id","value":group.workarea,"options":_vm.workareas},on:{"input":function (value) { return _vm.updateWorkarea(value, group); }}})],1)],1)}))])])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-sm-7"},[_c('h2',[_vm._v("Grupper")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',[_vm._v("Namn")]),_vm._v(" "),_c('th',[_vm._v("Hantera")]),_vm._v(" "),_c('th',[_vm._v("Yta")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 255:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Workareas_vue__ = __webpack_require__(256);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5c0aaf31_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Workareas_vue__ = __webpack_require__(257);
var normalizeComponent = __webpack_require__(10)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Workareas_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5c0aaf31_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Workareas_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 256:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);






/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'workareas',
    computed: {
        workareas: function workareas() {
            return this.$store.state.workarea.workareas;
        }
    },
    data: function data() {
        return {
            name: '',
            workarea: null
        };
    },
    mounted: function mounted() {
        this.refresh();
    },

    methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])({
        refresh: 'workarea_list',
        insert: 'workarea_post',
        remove: 'workarea_delete',
        select: 'workarea_select',
        silent: 'workarea_silent'
    }), {
        create: function create() {
            if (this.name === '' || this.name === undefined) {
                return;
            }

            this.insert(this.name);
        },
        selectForRemoval: function selectForRemoval(_ref) {
            var workarea = _ref.workarea,
                index = _ref.index;

            this.workarea = { workarea: workarea, index: index };
            this.$refs.removeConfirmation.show();
        },
        removeAction: function removeAction() {
            this.remove(this.workarea);
        },
        removeCancel: function removeCancel() {
            this.workarea = null;
        },
        getSilentStatus: function getSilentStatus(workarea) {
            var member = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(workarea.members, { id: this.$store.state.authentication.user.id });

            if (member !== null && member !== undefined) {
                return member.silent;
            }

            return false;
        },
        onSilentChanged: function onSilentChanged(workarea) {
            var member = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(workarea.members, { id: this.$store.state.authentication.user.id });

            if (member !== null && member !== undefined) {
                this.silent({ workarea: workarea, user: this.$store.state.authentication.user, silent: !member.silent });
            }
        }
    })
});

/***/ }),

/***/ 257:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"friends row justify-content-center"},[_c('b-modal',{ref:"removeConfirmation",attrs:{"id":"removeConfirmation","title":"Ta bort workarea","close-title":"Nej","ok-title":"Ja"},on:{"ok":_vm.removeAction,"cancel":_vm.removeCancel}},[_c('span',[_vm._v("Vill du ta bort din workarea?")])]),_vm._v(" "),_c('div',{staticClass:"col-md-8"},[_c('div',{staticClass:"row"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"col-sm"},[_c('div',{staticClass:"input-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.name),expression:"name"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Namn","required":"","autofocus":""},domProps:{"value":(_vm.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.name=$event.target.value}}}),_vm._v(" "),_c('span',{staticClass:"input-group-btn"},[_c('button',{staticClass:"btn btn-md btn-primary",attrs:{"type":"button"},on:{"click":function($event){_vm.create()}}},[_vm._v("Lägg till")])])])])]),_vm._v(" "),_c('table',{staticClass:"table table-bordered table-striped"},[_vm._m(1),_vm._v(" "),_c('tbody',_vm._l((_vm.workareas),function(workarea,index){return _c('tr',[_c('router-link',{attrs:{"tag":"td","active-class":"active","to":'/workarea/' + workarea.id,"exact":""},nativeOn:{"click":function($event){_vm.select({workarea: workarea, index: index})}}},[_c('a',[_vm._v(_vm._s(workarea.name))])]),_vm._v(" "),_c('td',[_c('button',{staticClass:"btn btn-primary",on:{"click":function($event){_vm.selectForRemoval({workarea: workarea, index: index})}}},[_vm._v("Ta bort")])]),_vm._v(" "),_c('td',[_c('b-form-checkbox',{attrs:{"value":_vm.getSilentStatus(workarea),"unchecked-value":false},on:{"change":function($event){_vm.onSilentChanged(workarea)}}})],1)],1)}))])])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-sm-7"},[_c('h2',[_vm._v("Workarea")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',[_vm._v("Namn")]),_vm._v(" "),_c('th',[_vm._v("Hantera")]),_vm._v(" "),_c('th',[_vm._v("Tyst")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 258:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Workarea_vue__ = __webpack_require__(259);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3ba60d02_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Workarea_vue__ = __webpack_require__(263);
var normalizeComponent = __webpack_require__(10)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Workarea_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3ba60d02_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Workarea_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 259:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_parts_Autocomplete__ = __webpack_require__(107);






/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'workarea',
    components: {
        Autocomplete: __WEBPACK_IMPORTED_MODULE_2__components_parts_Autocomplete__["a" /* default */]
    },
    computed: {
        workarea: function workarea() {
            return this.$store.getters.getActiveWorkarea;
        },
        index: function index() {
            return this.$store.state.workarea.active;
        },
        members: function members() {
            return this.$store.getters.getActiveWorkarea.members;
        },
        userId: function userId() {
            return this.$store.state.authentication.user.id;
        }
    },
    data: function data() {
        return {
            username: '',
            member: null
        };
    },
    mounted: function mounted() {
        this.refresh({ workarea: this.workarea, index: this.index });
    },

    methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])({
        refresh: 'workarea_members',
        remove: 'workarea_member_delete',
        create: 'workarea_member_post'
    }), Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])({
        getFriends: 'getFriendsList'
    }), {
        selectForRemoval: function selectForRemoval(_ref) {
            var workarea = _ref.workarea,
                member = _ref.member,
                index = _ref.index,
                memberIndex = _ref.memberIndex;

            this.member = { workarea: workarea, member: member, index: index, memberIndex: memberIndex };
            this.$refs.removeConfirmation.show();
        },
        removeAction: function removeAction() {
            this.remove(this.member);
        },
        removeCancel: function removeCancel() {
            this.member = null;
        }
    })
});

/***/ }),

/***/ 260:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 261:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'Autocomplete',
    props: {
        options: {
            type: Array,
            required: true
        },
        value: {
            type: String
        }
    },
    data: function data() {
        return {
            isOpen: false,
            highlightedPosition: 0,
            keyword: ''
        };
    },

    computed: {
        fOptions: function fOptions() {
            var re = new RegExp(this.keyword, 'i');
            return this.options.filter(function (o) {
                return o.match(re);
            });
        }
    },
    methods: {
        onInput: function onInput(value) {
            this.highlightedPosition = 0;
            this.isOpen = !!value;
            this.$emit('input', value);
        },
        moveDown: function moveDown() {
            if (!this.isOpen) {
                return;
            }
            this.highlightedPosition = (this.highlightedPosition + 1) % this.fOptions.length;
        },
        moveUp: function moveUp() {
            if (!this.isOpen) {
                return;
            }
            this.highlightedPosition = this.highlightedPosition - 1 < 0 ? this.fOptions.length - 1 : this.highlightedPosition - 1;
        },
        select: function select() {
            var selectedOption = this.fOptions[this.highlightedPosition];
            this.$emit('select', selectedOption);
            this.isOpen = false;
            this.keyword = selectedOption;
        }
    }
});

/***/ }),

/***/ 262:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"autocomplete-input"},[_c('p',{staticClass:"control has-icon has-icon-right"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.keyword),expression:"keyword"}],staticClass:"input is-large",attrs:{"placeholder":"Användarnamn"},domProps:{"value":(_vm.keyword)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.keyword=$event.target.value},function($event){_vm.onInput($event.target.value)}],"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"esc",27,$event.key)){ return null; }_vm.isOpen = false},"blur":function($event){_vm.isOpen = false},"keydown":[function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"down",40,$event.key)){ return null; }_vm.moveDown($event)},function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"up",38,$event.key)){ return null; }_vm.moveUp($event)},function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key)){ return null; }_vm.select($event)}]}})]),_vm._v(" "),_c('ul',{directives:[{name:"show",rawName:"v-show",value:(_vm.isOpen),expression:"isOpen"}],staticClass:"options-list"},_vm._l((_vm.fOptions),function(option,index){return _c('li',{class:{
        'highlighted': index === _vm.highlightedPosition
      },on:{"mouseenter":function($event){_vm.highlightedPosition = index},"mousedown":_vm.select}},[_vm._t("item",null,{title:option})],2)}))])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 263:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"workarea row justify-content-center"},[_c('b-modal',{ref:"removeConfirmation",attrs:{"id":"removeConfirmation","title":"Ta bort medlem","close-title":"Nej","ok-title":"Ja"},on:{"ok":_vm.removeAction,"cancel":_vm.removeCancel}},[_c('span',[_vm._v("Vill du ta bort medlemmen?")])]),_vm._v(" "),_c('div',{staticClass:"col-md-8"},[_c('div',{staticClass:"row"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"col-sm"},[_c('div',{staticClass:"input-group"},[_c('Autocomplete',{attrs:{"options":_vm.getFriends()},scopedSlots:_vm._u([{key:"item",fn:function(option){return [_c('p',[_c('strong',[_vm._v(_vm._s(option.title))])])]}}]),model:{value:(_vm.username),callback:function ($$v) {_vm.username=$$v},expression:"username"}}),_vm._v(" "),_c('span',{staticClass:"input-group-btn"},[_c('button',{staticClass:"btn btn-md btn-primary",attrs:{"type":"button"},on:{"click":function($event){_vm.create({workarea: _vm.workarea, username: _vm.username, index: _vm.index})}}},[_vm._v("Lägg till")])])],1)])]),_vm._v(" "),_c('table',{staticClass:"table table-bordered table-striped"},[_vm._m(1),_vm._v(" "),_c('tbody',_vm._l((_vm.workarea.members),function(member,memberIndex){return _c('tr',[_c('td',[_vm._v(_vm._s(member.username))]),_vm._v(" "),_c('td',[(member.id !== _vm.userId)?_c('button',{staticClass:"btn btn-primary",on:{"click":function($event){_vm.selectForRemoval({workarea: _vm.workarea, member: member, index: _vm.index, memberIndex: memberIndex})}}},[_vm._v("Ta bort")]):_vm._e()])])}))])])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-sm-7"},[_c('h2',[_vm._v("Medlemmar")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',[_vm._v("Namn")]),_vm._v(" "),_c('th',[_vm._v("Hantera")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 264:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Group_vue__ = __webpack_require__(266);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7eb8dcae_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Group_vue__ = __webpack_require__(268);
function injectStyle (ssrContext) {
  __webpack_require__(265)
}
var normalizeComponent = __webpack_require__(10)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Group_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7eb8dcae_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Group_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 265:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 266:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_at_dist_vue_at_textarea__ = __webpack_require__(267);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_at_dist_vue_at_textarea___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_at_dist_vue_at_textarea__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_parts_Autocomplete__ = __webpack_require__(107);







/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'group',
    components: {
        AtTa: __WEBPACK_IMPORTED_MODULE_2_vue_at_dist_vue_at_textarea___default.a,
        Autocomplete: __WEBPACK_IMPORTED_MODULE_3__components_parts_Autocomplete__["a" /* default */]
    },
    computed: {
        group: function group() {
            return this.$store.getters.getActiveGroup;
        },
        index: function index() {
            return this.$store.state.group.active;
        },
        members: function members() {
            return this.$store.getters.getActiveGroup.members;
        }
    },
    data: function data() {
        return {
            username: '',
            member: null
        };
    },
    mounted: function mounted() {
        this.username = '';
        this.refresh({ group: this.group, index: this.index });
    },

    methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])({
        refresh: 'group_members',
        remove: 'group_member_delete',
        insert_member_internal: 'group_member_post'
    }), Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])({
        getFriends: 'getFriendsList'
    }), {
        addMember: function addMember(_ref) {
            var group = _ref.group,
                username = _ref.username,
                index = _ref.index;

            this.insert_member_internal({ group: group, username: username, index: index });
            this.username = '';
        },
        selectForRemoval: function selectForRemoval(_ref2) {
            var group = _ref2.group,
                member = _ref2.member,
                index = _ref2.index,
                memberIndex = _ref2.memberIndex;

            this.member = { group: group, member: member, index: index, memberIndex: memberIndex };
            this.$refs.removeConfirmation.show();
        },
        removeAction: function removeAction() {
            this.remove(this.member);
        },
        removeCancel: function removeCancel() {
            this.member = null;
        }
    })
});

/***/ }),

/***/ 268:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"group row justify-content-center"},[_c('b-modal',{ref:"removeConfirmation",attrs:{"id":"removeConfirmation","title":"Ta bort medlem","close-title":"Nej","ok-title":"Ja"},on:{"ok":_vm.removeAction,"cancel":_vm.removeCancel}},[_c('span',[_vm._v("Vill du ta bort medlemmen?")])]),_vm._v(" "),_c('div',{staticClass:"col-md-8"},[_c('div',{staticClass:"row"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"col-sm"},[_c('div',{staticClass:"input-group"},[_c('Autocomplete',{attrs:{"options":_vm.getFriends()},scopedSlots:_vm._u([{key:"item",fn:function(option){return [_c('p',[_c('strong',[_vm._v(_vm._s(option.title))])])]}}]),model:{value:(_vm.username),callback:function ($$v) {_vm.username=$$v},expression:"username"}}),_vm._v(" "),_c('span',{staticClass:"input-group-btn"},[_c('button',{staticClass:"btn btn-md btn-primary",attrs:{"type":"button"},on:{"click":function($event){_vm.addMember({group: _vm.group, username: _vm.username, index: _vm.index})}}},[_vm._v("Lägg till")])])],1)])]),_vm._v(" "),_c('table',{staticClass:"table table-bordered table-striped"},[_vm._m(1),_vm._v(" "),_c('tbody',_vm._l((_vm.members),function(member,memberIndex){return _c('tr',[_c('td',[_vm._v(_vm._s(member.username))]),_vm._v(" "),_c('td',[_c('button',{staticClass:"btn btn-primary",on:{"click":function($event){_vm.selectForRemoval({group: _vm.group, member: member, index: _vm.index, memberIndex: memberIndex})}}},[_vm._v("Ta bort")])])])}))])])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-sm-7"},[_c('h2',[_vm._v("Medlemmar")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',[_vm._v("Namn")]),_vm._v(" "),_c('th',[_vm._v("Hantera")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 269:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Task_vue__ = __webpack_require__(271);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4cbb6976_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Task_vue__ = __webpack_require__(272);
function injectStyle (ssrContext) {
  __webpack_require__(270)
}
var normalizeComponent = __webpack_require__(10)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Task_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4cbb6976_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Task_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 270:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 271:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_helper__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_parser__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_marked__ = __webpack_require__(152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_marked___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_marked__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_addins_AtTextarea__ = __webpack_require__(149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_datetime__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_datetime___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_datetime__);











__WEBPACK_IMPORTED_MODULE_5_marked___default.a.setOptions({
    sanitize: true,
    gfm: true,
    breaks: true
});

/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'task',
    components: {
        AtTextarea: __WEBPACK_IMPORTED_MODULE_6__components_addins_AtTextarea__["a" /* default */],
        Datetime: __WEBPACK_IMPORTED_MODULE_7_vue_datetime__["Datetime"]
    },
    computed: {
        task: function task() {
            return this.$store.getters.getTask(this.$route.params.id);
        },
        index: function index() {
            return this.$store.state.task.active;
        },
        messages: function messages() {
            return __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.orderBy(this.$store.getters.getTask(this.$route.params.id).messages, ['created_at'], ['desc']);
        },
        markdown: function markdown() {
            return __WEBPACK_IMPORTED_MODULE_5_marked___default()(this.task.content);
        },
        workarea: function workarea() {
            return __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.find(this.$store.state.workarea.workareas, { id: this.task.workarea });
        },
        workareas: function workareas() {
            return this.$store.state.workarea.workareas;
        }
    },
    data: function data() {
        return {
            content: '',
            message: '',
            selectedWorkarea: null,
            simplemde: null,
            statusOptions: [{ text: 'Öppen', value: 1 }, { text: 'Avslutad', value: 2 }, { text: 'Planerad', value: 3 }, { text: 'Pågående', value: 4 }, { text: 'Avvakta', value: 5 }, { text: 'Klar', value: 6 }],
            sharedStatusOptions: [{ text: 'Nej', value: 0, disabled: true }, { text: 'Skickad', value: 1, disabled: true }, { text: 'Mottagen', value: 2, disabled: true }, { text: 'Läst', value: 3 }, { text: 'Accepterad', value: 4 }, { text: 'Nekad', value: 5 }, { text: 'Klar', value: 6 }, { text: 'Avslutad', value: 7 }],
            selectedStatus: 0,
            selectedSharedStatus: 0,
            userLimit: null,
            old: false,
            updatedAt: null,
            deadline: null
        };
    },
    mounted: function mounted() {
        this.updatedAt = this.task.updated_at;

        this.refresh(this.task.id);

        this.select({ task: this.task });

        this.selectedStatus = this.task.status;

        this.selectedSharedStatus = this.task.shared_status;

        if (this.workarea) {
            this.selectedWorkarea = this.workarea;
        }

        this.deadline = this.task.deadline;
        console.log('Deadline', this.task.deadline, this.deadline);

        if (this.task.user_limit !== undefined && this.task.user_limit !== null) {
            this.userLimit = this.task.user_limit.toString();
        }

        this.content = this.task.content;
    },

    watch: {
        task: function task() {
            if (this.content !== this.task.content && this.updatedAt !== this.task.updated_at) {
                this.old = true;
            }
        },
        selectedStatus: function selectedStatus() {
            if (this.task.status !== this.selectedStatus && this.selectedStatus !== 0) {
                this.updateStatus({ task: this.task, status: this.selectedStatus });
            }
        },
        selectedSharedStatus: function selectedSharedStatus() {
            if (this.task.shared_status !== this.selectedSharedStatus && this.selectedSharedStatus !== 0) {
                if (this.selectedSharedStatus === 6) {
                    this.updateStatus({ task: this.task, status: 6 });
                }

                if (this.selectedSharedStatus === 7 || this.selectedSharedStatus === 5) {
                    this.updateStatus({ task: this.task, status: 2 });
                }

                this.updateSharedStatus({ task: this.task, status: this.selectedSharedStatus });
            }
        }
    },
    methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])({
        refresh: 'task_get',
        insert: 'task_put',
        insertMessage: 'task_message',
        updateStatus: 'task_status',
        updateSharedStatus: 'task_shared_status',
        select: 'task_select',
        markMessageRead: 'task_message_read'
    }), Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])({
        getFriends: 'getFriendsList'
    }), {
        createdTime: __WEBPACK_IMPORTED_MODULE_2__utils_helper__["a" /* default */].task.getCreatedTime,
        updatedTime: __WEBPACK_IMPORTED_MODULE_2__utils_helper__["a" /* default */].task.getUpdatedTime,
        createdTimeFull: __WEBPACK_IMPORTED_MODULE_2__utils_helper__["a" /* default */].task.getCreatedTimeFull,
        updatedTimeFull: __WEBPACK_IMPORTED_MODULE_2__utils_helper__["a" /* default */].task.getUpdatedTimeFull,
        sentTime: __WEBPACK_IMPORTED_MODULE_2__utils_helper__["a" /* default */].task.getSentTime,
        sentTimeFull: __WEBPACK_IMPORTED_MODULE_2__utils_helper__["a" /* default */].task.getSentTimeFull,
        formatTime: __WEBPACK_IMPORTED_MODULE_2__utils_helper__["a" /* default */].task.formatTime,
        formatTimeFull: __WEBPACK_IMPORTED_MODULE_2__utils_helper__["a" /* default */].task.formatTimeFull,
        creator: __WEBPACK_IMPORTED_MODULE_2__utils_helper__["a" /* default */].task.getCreator,
        statusString: __WEBPACK_IMPORTED_MODULE_2__utils_helper__["a" /* default */].status.toString,
        sharedStatusString: __WEBPACK_IMPORTED_MODULE_2__utils_helper__["a" /* default */].sharedStatus.toString,
        isCreator: function isCreator() {
            return this.$store.state.authentication.user.id === this.task.creator;
        },
        getAutocompleteList: function getAutocompleteList() {
            var friend = this.getFriends();
            var groups = this.$store.state.group.groups;

            groups = __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.map(groups, function (g) {
                return '@' + g.name;
            });

            return __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.concat(friend, groups);
        },
        isIncommingMessage: function isIncommingMessage(message) {
            return __WEBPACK_IMPORTED_MODULE_2__utils_helper__["a" /* default */].task.isIncommingMessage(this.task, this.$store.state.authentication.user, message, this.$store.state.workarea.workareas);
        },
        showUserInList: function showUserInList(user) {
            if (!this.isMember(user) && this.task.creator === user.user) {
                return false;
            }

            return true;
        },
        isSelf: function isSelf(user) {
            return user.user === this.$store.state.authentication.user.id;
        },
        isMember: function isMember() {
            return __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.find(this.task.users, { user: this.$store.state.authentication.user.id }) !== undefined;
        },
        isWorkspace: function isWorkspace(task) {
            return __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.find(this.$store.state.workarea.workareas, { id: this.task.workarea }) !== undefined;
        },
        getAreaName: function getAreaName() {
            if (this.workarea) {
                return this.workarea.name;
            }

            return 'Ingen';
        },
        update: function update() {
            var task = __WEBPACK_IMPORTED_MODULE_3__utils_parser__["a" /* default */].parse(this, this.content, null, this.userLimit, this.task.user_limit !== null && this.task.user_limit !== undefined && this.task.user_limit > 0);

            task.id = this.task.id;

            task.deadline = this.deadline;

            if (this.selectedWorkarea !== null && task.workarea !== this.selectedWorkarea.id) {
                task.workarea = this.selectedWorkarea.id;
            }

            this.insert({ task: task, back: true });
        },
        send: function send() {
            if (this.message === '' || this.message === null) {
                return;
            }

            this.insertMessage({ task: this.task, message: this.message });

            this.message = '';
        },
        changed: function changed(event) {
            this.content = event.target.textContent;
        },
        resetEditor: function resetEditor() {
            this.content = '';
        },
        markAsRead: function markAsRead(message, index) {
            this.markMessageRead({ task: this.task, message: message, index: index, user: this.$store.state.authentication.user });
        },
        isRead: function isRead(message) {
            return message.acknowledged_by !== null && message.acknowledged_by !== undefined;
        },
        shouldShowReadStatus: function shouldShowReadStatus(message) {
            if (message.user === this.$store.state.authentication.user.username) {
                return false;
            }

            return true;
        },
        setDeadline: function setDeadline() {
            this.deadline = new Date().toLocaleString();
            console.log(this.deadline);
        },
        getWorkareaMembers: function getWorkareaMembers() {
            if (this.workarea) {
                return this.workarea.members.length;
            }

            return 0;
        }
    })
});

/***/ }),

/***/ 272:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"task row justify-content-center"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-3"},[_c('div',{staticClass:"row justify-content-center"},[_c('h5',[_vm._v("Meddelande")]),_vm._v(" "),(_vm.isCreator() || _vm.isMember() || _vm.isWorkspace())?_c('div',{staticClass:"input-group margin"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.message),expression:"message"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Meddelande"},domProps:{"value":(_vm.message)},on:{"input":function($event){if($event.target.composing){ return; }_vm.message=$event.target.value}}}),_vm._v(" "),_c('span',{staticClass:"input-group-btn"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button"},on:{"click":_vm.send}},[_vm._v("Skicka")])])]):_vm._e(),_vm._v(" "),_vm._l((_vm.task.messages),function(message,index){return _c('div',{staticClass:"row w-100 row-spacing"},[_c('b-card',{staticClass:"w-100",class:{'incoming': _vm.isIncommingMessage(message), 'outgoing': !_vm.isIncommingMessage(message)},attrs:{"show-header":"","show-footer":""}},[_c('div',{staticClass:"row",attrs:{"slot":"header"},slot:"header"},[_c('div',{staticClass:"col-sm-9"},[_c('span',[_vm._v("@"+_vm._s(message.user))])]),_vm._v(" "),(!_vm.isRead(message) && _vm.isIncommingMessage(message))?_c('div',{staticClass:"col-sm-1 mark"},[_c('b-button',{attrs:{"variant":"success","size":"sm"},on:{"click":function($event){_vm.markAsRead(message, index)}}},[_c('i',{staticClass:"material-icons"},[_vm._v("")])])],1):_vm._e(),_vm._v(" "),(!_vm.isRead(message) && !_vm.isIncommingMessage(message))?_c('div',{staticClass:"col-sm-1 spacing"},[_c('b-badge',{attrs:{"pill":"","variant":"danger"}},[_vm._v("Unread")])],1):_vm._e()]),_vm._v("\n                      "+_vm._s(message.message)+"\n                      "),_c('div',{attrs:{"slot":"footer"},slot:"footer"},[_vm._v("\n                      "+_vm._s(_vm.createdTime(message))+"\n                      ")])])],1)})],2)]),_vm._v(" "),_c('div',{staticClass:"col-sm-9"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-7"},[_c('h5',[_vm._v("Uppgift")]),_vm._v(" "),_c('div',{staticClass:"row justify-content-center"},[(_vm.isCreator() || _vm.isWorkspace())?_c('form',{on:{"submit":function($event){$event.preventDefault();_vm.update($event)}}},[_c('at-textarea',{attrs:{"members":_vm.getAutocompleteList()}},[_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.content),expression:"content"}],staticClass:"editor",domProps:{"value":(_vm.content)},on:{"input":function($event){if($event.target.composing){ return; }_vm.content=$event.target.value}}})]),_vm._v(" "),_c('button',{staticClass:"btn btn-md btn-primary btn-block",attrs:{"type":"submit"}},[_vm._v("Uppdatera")])],1):_c('b-card',{staticClass:"w-100 task-box"},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.task.content_parsed)}})])],1)]),_vm._v(" "),_c('div',{staticClass:"col-sm-5"},[_c('div',{staticClass:"row"},[_c('h5',[_vm._v("Information")]),_vm._v(" "),_c('table',{staticClass:"table table-bordered table-striped"},[_c('tbody',[(_vm.task.workarea && (!_vm.isCreator() || _vm.getWorkareaMembers() > 1))?_c('tr',[_c('td',[_vm._v("Arbetsyta")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.getAreaName()))])]):_vm._e(),_vm._v(" "),(_vm.task.workarea && _vm.isCreator() && _vm.getWorkareaMembers() < 2)?_c('tr',[_c('td',[_vm._v("Arbetsyta")]),_vm._v(" "),_c('td',[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedWorkarea),expression:"selectedWorkarea"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.selectedWorkarea=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},_vm._l((_vm.workareas),function(workarea){return _c('option',{key:workarea.id,domProps:{"value":workarea}},[_vm._v("\n                                              "+_vm._s(workarea.name)+"\n                                          ")])}))])]):_vm._e(),_vm._v(" "),(!_vm.task.workarea && _vm.isCreator())?_c('tr',[_c('td',[_vm._v("Arbetsyta")]),_vm._v(" "),_c('td',[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedWorkarea),expression:"selectedWorkarea"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.selectedWorkarea=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},_vm._l((_vm.workareas),function(workarea){return _c('option',{key:workarea.id,domProps:{"value":workarea}},[_vm._v("\n                                              "+_vm._s(workarea.name)+"\n                                          ")])}))])]):_vm._e(),_vm._v(" "),(_vm.task.updated_at)?_c('tr',[_c('td',{class:{old: this.old}},[_vm._v("Uppdaterad")]),_vm._v(" "),_c('td',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip"}],class:{old: this.old},attrs:{"title":_vm.updatedTimeFull(_vm.task)}},[_vm._v(_vm._s(_vm.updatedTime(_vm.task)))])]):_vm._e(),_vm._v(" "),(_vm.task.created_at)?_c('tr',[_c('td',[_vm._v("Skapad")]),_vm._v(" "),_c('td',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip"}],attrs:{"title":_vm.createdTimeFull(_vm.task)}},[_vm._v(_vm._s(_vm.createdTime(_vm.task)))])]):_vm._e(),_vm._v(" "),_c('tr',[_c('td',[_vm._v("Skapare")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.creator(_vm.task).username))])]),_vm._v(" "),(_vm.task.sent_at)?_c('tr',[_c('td',[_vm._v("Skickad")]),_vm._v(" "),_c('td',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip"}],attrs:{"title":_vm.sentTimeFull(_vm.task)}},[_vm._v(_vm._s(_vm.sentTime(_vm.task)))])]):_vm._e(),_vm._v(" "),(_vm.deadline)?_c('tr',[_c('td',[_vm._v("Förfaller")]),_vm._v(" "),_c('td',[_c('Datetime',{staticClass:"form-control",attrs:{"type":"datetime","monday-first":"","auto-continue":""},model:{value:(_vm.deadline),callback:function ($$v) {_vm.deadline=$$v},expression:"deadline"}})],1)]):_c('tr',[_c('td',[_vm._v("Förfaller")]),_vm._v(" "),_c('td',[_c('button',{staticClass:"btn btn-md btn-outline-success btn-block",attrs:{"type":"submit"},on:{"click":_vm.setDeadline}},[_vm._v("Sätt")])])]),_vm._v(" "),(_vm.isCreator() || _vm.isWorkspace())?_c('tr',[_c('td',[_vm._v("Status")]),_vm._v(" "),_c('td',[_c('b-form-select',{staticClass:"mb-3",attrs:{"options":_vm.statusOptions},model:{value:(_vm.selectedStatus),callback:function ($$v) {_vm.selectedStatus=$$v},expression:"selectedStatus"}})],1)]):_vm._e(),_vm._v(" "),(!_vm.isCreator() && _vm.isMember())?_c('tr',[_c('td',[_vm._v("Delad")]),_vm._v(" "),_c('td',[_c('b-form-select',{staticClass:"mb-3",attrs:{"options":_vm.sharedStatusOptions},model:{value:(_vm.selectedSharedStatus),callback:function ($$v) {_vm.selectedSharedStatus=$$v},expression:"selectedSharedStatus"}})],1)]):_vm._e(),_vm._v(" "),_c('tr',[_c('td',[_vm._v("Max Mottagare")]),_vm._v(" "),_c('td',[_c('b-form-input',{attrs:{"type":"number"},model:{value:(_vm.userLimit),callback:function ($$v) {_vm.userLimit=$$v},expression:"userLimit"}})],1)])])])])])]),_vm._v(" "),_c('div',{staticClass:"row userbox"},[_c('h5',[_vm._v(_vm._s(_vm.isCreator() ? 'Mottagare' : 'Användare'))]),_vm._v(" "),_c('table',{staticClass:"table table-bordered table-striped"},[_vm._m(0),_vm._v(" "),_c('tbody',_vm._l((_vm.task.users),function(user){return (!_vm.isSelf(user) && _vm.showUserInList(user))?_c('tr',[_c('td',[_vm._v(_vm._s(user.username))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.statusString(user.status)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.sharedStatusString(user.shared_status)))]),_vm._v(" "),_c('td',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip"}],attrs:{"title":_vm.formatTimeFull(user.read_at)}},[_vm._v(_vm._s(_vm.formatTime(user.read_at)))]),_vm._v(" "),_c('td',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip"}],attrs:{"title":_vm.formatTimeFull(user.accepted_at)}},[_vm._v(_vm._s(_vm.formatTime(user.accepted_at)))]),_vm._v(" "),_c('td',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip"}],attrs:{"title":_vm.formatTimeFull(user.finished_at)}},[_vm._v(_vm._s(_vm.formatTime(user.finished_at)))])]):_vm._e()}))])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',[_vm._v("Användarnamn")]),_vm._v(" "),_c('th',[_vm._v("Status")]),_vm._v(" "),_c('th',[_vm._v("Delad")]),_vm._v(" "),_c('th',[_vm._v("Läst")]),_vm._v(" "),_c('th',[_vm._v("Accepterad")]),_vm._v(" "),_c('th',[_vm._v("Klar/Nekad")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 274:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_helper__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__router__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__bugsnag__ = __webpack_require__(29);








function getInitialState() {
    return {
        tasks: [],
        active: '',
        messages: {},
        last_sync: null,
        syncing: false
    };
}

var state = getInitialState();

var mutations = {
    'INSERT_TASK_LIST': function INSERT_TASK_LIST(state, tasks) {
        if (tasks === null || tasks === undefined) {
            return;
        }

        __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.each(tasks, function (task) {
            if (task.messages === null || task.messages === undefined) {
                task.messages = [];
            }

            var index = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.findIndex(state.tasks, { id: task.id });

            if (index < 0) {
                state.tasks.push(task);
            } else {
                state.tasks.splice(index, 1, task);
            }
        });
    },
    'REMOVE_TASK': function REMOVE_TASK(state, _ref) {
        var task = _ref.task,
            _ref$index = _ref.index,
            index = _ref$index === undefined ? null : _ref$index;

        index = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.findIndex(state.tasks, { id: task.id });

        state.tasks.splice(index, 1);
    },
    'UPSERT_TASK': function UPSERT_TASK(state, _ref2) {
        var task = _ref2.task,
            _ref2$index = _ref2.index,
            index = _ref2$index === undefined ? null : _ref2$index;

        if (index === null || index >= state.tasks.length) {
            index = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.findIndex(state.tasks, { id: task.id });
        }

        if (task.messages === null || task.messages === undefined) {
            task.messages = [];
        }

        if (index === -1) {
            state.tasks.push(task);
        } else {
            state.tasks.splice(index, 1, task);
        }
    },
    'SET_ACTIVE_TASK': function SET_ACTIVE_TASK(state, _ref3) {
        var task = _ref3.task,
            _ref3$index = _ref3.index,
            index = _ref3$index === undefined ? null : _ref3$index;

        index = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.indexOf(state.tasks, task);

        state.active = state.tasks[index].id;
    },
    'REMOVE_ACTIVE_TASK': function REMOVE_ACTIVE_TASK(state) {
        state.active = null;
    },
    'ADD_MESSAGE': function ADD_MESSAGE(state, _ref4) {
        var task = _ref4.task,
            message = _ref4.message,
            _ref4$index = _ref4.index,
            index = _ref4$index === undefined ? null : _ref4$index;

        if (index === null || index >= state.tasks.length) {
            index = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.findIndex(state.tasks, { id: task.id });
        }

        if (state.tasks[index].messages === null) {
            state.tasks[index].messages = [message];
        } else {
            state.tasks[index].messages.push(message);
        }
    },
    'TASK_SYNC_DONE': function TASK_SYNC_DONE(state) {
        state.last_sync = new Date().toISOString();
    },
    'TASK_SYNC_START': function TASK_SYNC_START(state) {
        state.syncing = true;
    },
    'TASK_SYNC_STOP': function TASK_SYNC_STOP(state) {
        state.syncing = false;
    },
    'RESET_TASK': function RESET_TASK(state) {
        state = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(state, getInitialState());
    }
};

var actions = {
    task_list: function task_list(_ref5, _ref6) {
        var commit = _ref5.commit,
            state = _ref5.state;
        var _ref6$offset = _ref6.offset,
            offset = _ref6$offset === undefined ? 0 : _ref6$offset,
            _ref6$everything = _ref6.everything,
            everything = _ref6$everything === undefined ? false : _ref6$everything;

        var from = '';
        commit('TASK_SYNC_START');
        if (state.last_sync !== null && everything === false) {
            console.log('Synchronizing changes since: ' + state.last_sync);
            from = '&after=' + state.last_sync;
        }

        __WEBPACK_IMPORTED_MODULE_2_vue__["default"].http.get('tasks?offset=' + offset + from).then(function (response) {
            commit('INSERT_TASK_LIST', response.body.data.tasks);

            if (response.body.data.tasks !== null) {
                actions.task_list({ commit: commit, state: state }, { offset: offset + response.body.data.tasks.length, everything: everything });
            } else {
                if (offset !== 0) {
                    commit('TASK_SYNC_DONE');
                }

                commit('TASK_SYNC_STOP');
            }
        }).catch(function (error) {
            commit('TASK_SYNC_STOP');

            __WEBPACK_IMPORTED_MODULE_6__bugsnag__["a" /* default */].notify(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(error));
        });
    },
    task_get: function task_get(_ref7, id) {
        var commit = _ref7.commit;

        __WEBPACK_IMPORTED_MODULE_2_vue__["default"].http.get('task/' + id).then(function (response) {
            commit('UPSERT_TASK', { task: response.body.data });
        }).catch(function (error) {
            __WEBPACK_IMPORTED_MODULE_6__bugsnag__["a" /* default */].notify(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(error));
        });
    },
    task_get_move: function task_get_move(_ref8, _ref9) {
        var commit = _ref8.commit;
        var id = _ref9.id,
            _ref9$back = _ref9.back,
            back = _ref9$back === undefined ? false : _ref9$back;

        __WEBPACK_IMPORTED_MODULE_2_vue__["default"].http.get('task/' + id).then(function (response) {
            commit('UPSERT_TASK', { task: response.body.data });

            if (back) {
                __WEBPACK_IMPORTED_MODULE_5__router__["a" /* default */].push({ name: 'Main' });
            }
        }).catch(function (error) {
            __WEBPACK_IMPORTED_MODULE_6__bugsnag__["a" /* default */].notify(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(error));
        });
    },
    task_put: function task_put(_ref10, _ref11) {
        var commit = _ref10.commit;
        var task = _ref11.task,
            _ref11$back = _ref11.back,
            back = _ref11$back === undefined ? false : _ref11$back;

        __WEBPACK_IMPORTED_MODULE_2_vue__["default"].http.put('task/' + task.id, __WEBPACK_IMPORTED_MODULE_4__utils_helper__["a" /* default */].task.toBody(task)).then(function (response) {
            actions.task_get_move({ commit: commit }, { id: task.id, back: back });
        }).catch(function (error) {
            __WEBPACK_IMPORTED_MODULE_6__bugsnag__["a" /* default */].notify(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(error));
        });
    },
    task_delete: function task_delete(_ref12, _ref13) {
        var commit = _ref12.commit;
        var task = _ref13.task,
            index = _ref13.index;

        __WEBPACK_IMPORTED_MODULE_2_vue__["default"].http.delete('task/' + task.id).then(function (response) {
            commit('REMOVE_TASK', { task: task, index: index });
        }).catch(function (error) {
            __WEBPACK_IMPORTED_MODULE_6__bugsnag__["a" /* default */].notify(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(error));
        });
    },
    task_post: function task_post(_ref14, task) {
        var commit = _ref14.commit;

        console.log('TTAASSK', task);
        __WEBPACK_IMPORTED_MODULE_2_vue__["default"].http.post('tasks', __WEBPACK_IMPORTED_MODULE_4__utils_helper__["a" /* default */].task.toBody(task)).then(function (response) {
            actions.task_get({ commit: commit }, response.body.data);
        }).catch(function (error) {
            __WEBPACK_IMPORTED_MODULE_6__bugsnag__["a" /* default */].notify(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(error));
        });
    },
    task_select: function task_select(_ref15, _ref16) {
        var commit = _ref15.commit;
        var task = _ref16.task,
            index = _ref16.index;

        commit('SET_ACTIVE_TASK', { task: task, index: index });
    },
    task_message: function task_message(_ref17, _ref18) {
        var commit = _ref17.commit;
        var task = _ref18.task,
            message = _ref18.message,
            index = _ref18.index;

        __WEBPACK_IMPORTED_MODULE_2_vue__["default"].http.post('task/' + task.id + '/messages', { message: message }).then(function (response) {
            commit('ADD_MESSAGE', { task: task, message: response.body.data, index: index });
        }).catch(function (error) {
            __WEBPACK_IMPORTED_MODULE_6__bugsnag__["a" /* default */].notify(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(error));
        });
    },
    task_status: function task_status(_ref19, _ref20) {
        var commit = _ref19.commit;
        var task = _ref20.task,
            status = _ref20.status;

        task.status = status;
        actions.task_put({ commit: commit }, { task: task, back: false });
    },
    task_shared_status: function task_shared_status(_ref21, _ref22) {
        var commit = _ref21.commit;
        var task = _ref22.task,
            status = _ref22.status;

        task.shared_status = status;
        actions.task_put({ commit: commit }, { task: task, back: false });
    },
    task_message_read: function task_message_read(_ref23, _ref24) {
        var commit = _ref23.commit;
        var task = _ref24.task,
            message = _ref24.message,
            index = _ref24.index,
            user = _ref24.user;

        var time = new Date().toISOString();
        __WEBPACK_IMPORTED_MODULE_2_vue__["default"].http.put('task/' + task.id + '/message/' + message.id, { acknowledged_by: user.id, acknowledged_at: time }).then(function (response) {
            var index = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.indexOf(task.messages, message);

            if (index > -1) {
                message.acknowledged_by = user.id;
                message.acknowledged_at = time;
                task.messages[index] = message;
                commit('UPSERT_TASK', { task: task });
            }
        }).catch(function (error) {
            __WEBPACK_IMPORTED_MODULE_6__bugsnag__["a" /* default */].notify(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(error));
        });
    }
};

var getters = {
    getFilteredTasks: function getFilteredTasks(state, getters) {
        return function () {
            var content = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
            var orderKey = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'created_at';
            var order = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'asc';
            var _ref25 = arguments[3];
            var _ref25$tag = _ref25.tag,
                tag = _ref25$tag === undefined ? null : _ref25$tag,
                _ref25$category = _ref25.category,
                category = _ref25$category === undefined ? null : _ref25$category;
            var shared = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 'all';
            var favorites = arguments[5];
            var deadline = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : 'all';

            var filters = getters.getFilters;

            return __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.chain(state.tasks).filter(function (task) {
                return task.status < 100;
            }).filter(function (task) {
                return __WEBPACK_IMPORTED_MODULE_4__utils_helper__["a" /* default */].task.hasCorrectSharedStatus(task, shared, getters.getAuthenticatedUser, filters.workarea);
            }).filter(function (task) {
                return __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.includes(filters.statuses, __WEBPACK_IMPORTED_MODULE_4__utils_helper__["a" /* default */].task.getCorrectStatus(task, getters.getAuthenticatedUser, filters.workarea, getters.getWorkareas));
            }).filter(function (task) {
                return filters.workarea === null || filters.workarea.id === task.workarea;
            }).filter(function (task) {
                return task.content.toLowerCase().indexOf(content.toLowerCase()) > -1;
            }).filter(function (task) {
                return tag === null || __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.includes(task.tags, tag);
            }).filter(function (task) {
                return category === null || __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.includes(task.categories, category);
            }).filter(function (task) {
                return __WEBPACK_IMPORTED_MODULE_4__utils_helper__["a" /* default */].task.hasDeadlineFilter(task, deadline);
            }).orderBy([orderKey], [order]).orderBy([function (task) {
                return __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.includes(favorites, task.id) ? 1 : 0;
            }], ['desc']).value();
        };
    },
    getActiveTask: function getActiveTask(state) {
        var index = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.findIndex(state.tasks, { id: state.active });
        return state.tasks[index];
    },
    getTask: function getTask(state) {
        return function (id) {
            var index = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.findIndex(state.tasks, { id: id });
            return state.tasks[index];
        };
    }
};

/* harmony default export */ __webpack_exports__["a"] = ({
    state: state,
    mutations: mutations,
    actions: actions,
    getters: getters
});

/***/ }),

/***/ 275:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(276);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__bugsnag__ = __webpack_require__(29);






function getInitialState() {
    return {
        authenticated: false,
        user: {},
        token: ''
    };
}

var state = getInitialState();

var mutations = {
    'AUTH_SET_TOKEN': function AUTH_SET_TOKEN(state, token) {
        state.token = token;
        __WEBPACK_IMPORTED_MODULE_3_vue__["default"].http.headers.common['Authorization'] = 'Bearer ' + token;
    },
    'AUTH_LOGIN': function AUTH_LOGIN(state, _ref) {
        var user = _ref.user,
            token = _ref.token;

        state.user = user;
        state.token = token;
        state.authenticated = true;
        __WEBPACK_IMPORTED_MODULE_3_vue__["default"].http.headers.common['Authorization'] = 'Bearer ' + token;
    },
    'AUTH_UPDATE': function AUTH_UPDATE(state, user) {
        state.user = user;
    },
    'AUTH_LOGOUT': function AUTH_LOGOUT(state) {
        state = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()(state, getInitialState());
        delete __WEBPACK_IMPORTED_MODULE_3_vue__["default"].http.headers.common['Authorization'];
    }
};

var actions = {
    auth_login: function auth_login(_ref2, _ref3) {
        var commit = _ref2.commit,
            dispatch = _ref2.dispatch;
        var username = _ref3.username,
            password = _ref3.password;

        return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
            __WEBPACK_IMPORTED_MODULE_3_vue__["default"].http.post('users/authentication', null, { headers: {
                    'Authorization': 'Basic ' + btoa(username + ':' + password)
                } }).then(function (response) {
                var token = response.body.Token;

                __WEBPACK_IMPORTED_MODULE_3_vue__["default"].http.get('user/me', { headers: {
                        'Authorization': 'Bearer ' + token
                    } }).then(function (response) {
                    commit('AUTH_LOGIN', { user: response.body.data.user, token: token });

                    __WEBPACK_IMPORTED_MODULE_4__bugsnag__["a" /* default */].user = {
                        id: response.body.data.user.id,
                        name: response.body.data.user.username,
                        email: response.body.data.user.email
                    };

                    resolve();
                }).catch(function (error) {
                    __WEBPACK_IMPORTED_MODULE_4__bugsnag__["a" /* default */].notify(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(error));
                    reject(error);
                });
            }).catch(function (error) {
                __WEBPACK_IMPORTED_MODULE_4__bugsnag__["a" /* default */].notify(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(error));
                reject(error);
            });
        });
    },
    auth_register: function auth_register(_ref4, _ref5) {
        var commit = _ref4.commit,
            dispatch = _ref4.dispatch;
        var username = _ref5.username,
            password = _ref5.password,
            email = _ref5.email;

        return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
            __WEBPACK_IMPORTED_MODULE_3_vue__["default"].http.post('users', { username: username, password: password, email: email }).then(function (response) {
                actions.auth_login({ commit: commit, dispatch: dispatch }, { username: username, password: password }).then(function () {
                    resolve();
                }).catch(function (error) {
                    __WEBPACK_IMPORTED_MODULE_4__bugsnag__["a" /* default */].notify(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(error));
                    reject(error);
                });
            }).catch(function (error) {
                __WEBPACK_IMPORTED_MODULE_4__bugsnag__["a" /* default */].notify(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(error));
                reject(error);
            });
        });
    },
    auth_register_member: function auth_register_member(_ref6, _ref7) {
        var commit = _ref6.commit,
            dispatch = _ref6.dispatch;
        var username = _ref7.username,
            password = _ref7.password,
            email = _ref7.email,
            organisation = _ref7.organisation,
            permission = _ref7.permission;

        return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
            __WEBPACK_IMPORTED_MODULE_3_vue__["default"].http.post('users', { username: username, password: password, email: email, organisation: organisation.id, permission_level: permission }).then(function (response) {
                resolve();
            }).catch(function (error) {
                __WEBPACK_IMPORTED_MODULE_4__bugsnag__["a" /* default */].notify(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(error));
                reject(error);
            });
        });
    },
    auth_update: function auth_update(_ref8, _ref9) {
        var commit = _ref8.commit;
        var user = _ref9.user,
            _ref9$password = _ref9.password,
            password = _ref9$password === undefined ? null : _ref9$password,
            _ref9$email = _ref9.email,
            email = _ref9$email === undefined ? null : _ref9$email,
            _ref9$workarea = _ref9.workarea,
            workarea = _ref9$workarea === undefined ? null : _ref9$workarea;

        __WEBPACK_IMPORTED_MODULE_3_vue__["default"].http.put('user/' + user.id, { password: password, email: email, workarea: workarea }).then(function (response) {
            commit('AUTH_UPDATE', response.body.data.user);
        }).catch(function (error) {
            __WEBPACK_IMPORTED_MODULE_4__bugsnag__["a" /* default */].notify(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(error));

            if (error.status === 401) {
                commit('AUTH_LOGOUT');
            }
        });
    },
    auth_logout: function auth_logout(_ref10) {
        var commit = _ref10.commit;

        return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
            commit('AUTH_LOGOUT');
            resolve();
        });
    }
};

var getters = {
    getAuthenticatedUser: function getAuthenticatedUser(state, getters) {
        return state.user;
    }
};

/* harmony default export */ __webpack_exports__["a"] = ({
    state: state,
    mutations: mutations,
    actions: actions,
    getters: getters
});

/***/ }),

/***/ 29:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_bugsnag_js__ = __webpack_require__(246);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_bugsnag_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_bugsnag_js__);

var bug = __WEBPACK_IMPORTED_MODULE_0_bugsnag_js___default()('91bb623f674484e6a090ea839c1a8c00');
/* harmony default export */ __webpack_exports__["a"] = (bug);

/***/ }),

/***/ 291:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__bugsnag__ = __webpack_require__(29);






function getInitialState() {
    return {
        friends: []
    };
}

var state = getInitialState();

var mutations = {
    'INSERT_FRIEND_LIST': function INSERT_FRIEND_LIST(state, friends) {
        state.friends = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.unionBy(state.friends, friends, 'id');
    },
    'REMOVE_FRIEND': function REMOVE_FRIEND(state, _ref) {
        var friend = _ref.friend,
            _ref$index = _ref.index,
            index = _ref$index === undefined ? null : _ref$index;

        if (index !== null && index < state.friends.length) {
            state.friends.splice(index, 1);
        } else if (index === null) {
            __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.remove(state.friends, function (elem) {
                return elem.id === friend.id;
            });
        }
    },
    'INSERT_FRIEND': function INSERT_FRIEND(state, friend) {
        state.friends = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.unionBy(state.friends, [friend], 'id');
    },
    'ACCEPT_FRIEND': function ACCEPT_FRIEND(state, _ref2) {
        var friend = _ref2.friend,
            _ref2$index = _ref2.index,
            index = _ref2$index === undefined ? null : _ref2$index;

        if (index === null || index >= state.friends.length) {
            index = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.indexOf(state.friends, friend);
        }

        if (index !== -1) {
            state.friends[index].accepted = true;
        }
    },
    'FRIEND_RESET': function FRIEND_RESET(state) {
        state = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(state, getInitialState());
    }
};

var actions = {
    friend_list: function friend_list(_ref3) {
        var commit = _ref3.commit,
            rootState = _ref3.rootState;

        __WEBPACK_IMPORTED_MODULE_2_vue__["default"].http.get('user/' + rootState.authentication.user.id + '/friends').then(function (response) {
            commit('INSERT_FRIEND_LIST', response.body.data);
        }).catch(function (error) {
            __WEBPACK_IMPORTED_MODULE_4__bugsnag__["a" /* default */].notify(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(error));
        });
    },
    friend_post: function friend_post(_ref4, username) {
        var commit = _ref4.commit,
            rootState = _ref4.rootState;

        __WEBPACK_IMPORTED_MODULE_2_vue__["default"].http.post('user/' + rootState.authentication.user.id + '/friends', { username: username }).then(function (response) {
            commit('INSERT_FRIEND', response.body.data);
        }).catch(function (error) {
            __WEBPACK_IMPORTED_MODULE_4__bugsnag__["a" /* default */].notify(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(error));
        });
    },
    friend_put: function friend_put(_ref5, friend) {
        var commit = _ref5.commit,
            rootState = _ref5.rootState;

        __WEBPACK_IMPORTED_MODULE_2_vue__["default"].http.put('user/' + rootState.authentication.user.id + '/friend/' + friend.id, { accepted: true }).then(function (resposne) {
            commit('ACCEPT_FRIEND', { friend: friend });
        }).catch(function (error) {
            __WEBPACK_IMPORTED_MODULE_4__bugsnag__["a" /* default */].notify(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(error));
        });
    },
    friend_delete: function friend_delete(_ref6, _ref7) {
        var commit = _ref6.commit,
            rootState = _ref6.rootState;
        var friend = _ref7.friend,
            index = _ref7.index;

        __WEBPACK_IMPORTED_MODULE_2_vue__["default"].http.delete('user/' + rootState.authentication.user.id + '/friend/' + friend.id).then(function (response) {
            commit('REMOVE_FRIEND', { friend: friend, index: index });
        }).catch(function (error) {
            __WEBPACK_IMPORTED_MODULE_4__bugsnag__["a" /* default */].notify(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(error));
        });
    }
};

var getters = {
    getFriendsList: function getFriendsList(state, getters) {
        return __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.map(state.friends, 'username');
    }
};

/* harmony default export */ __webpack_exports__["a"] = ({
    state: state,
    mutations: mutations,
    actions: actions,
    getters: getters
});

/***/ }),

/***/ 292:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__bugsnag__ = __webpack_require__(29);






function getInitialState() {
    return {
        groups: [],
        active: -1
    };
}

var state = getInitialState();

var mutations = {
    'INSERT_GROUP_LIST': function INSERT_GROUP_LIST(state, groups) {
        state.groups = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.unionBy(groups, state.groups, 'id');
    },
    'REMOVE_GROUP': function REMOVE_GROUP(state, _ref) {
        var group = _ref.group,
            _ref$index = _ref.index,
            index = _ref$index === undefined ? null : _ref$index;

        if (index !== null && index < state.groups.length) {
            state.groups.splice(index, 1);
        } else if (index === null) {
            __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.remove(state.groups, function (elem) {
                return elem.id === group.id;
            });
        }
    },
    'INSERT_GROUP': function INSERT_GROUP(state, group) {
        if (group.members === null || group.members === undefined) {
            group.members = [];
        }

        state.groups = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.unionBy(state.groups, [group], 'id');
    },
    'INSERT_GROUP_MEMBER_LIST': function INSERT_GROUP_MEMBER_LIST(state, _ref2) {
        var group = _ref2.group,
            members = _ref2.members,
            _ref2$index = _ref2.index,
            index = _ref2$index === undefined ? null : _ref2$index;

        if (index === null || index >= state.groups.length) {
            index = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.indexOf(state.groups, group);
        }

        if (index !== -1) {
            if (members === null || members === undefined) {
                members = [];
            }

            state.groups[index].members = members;
        }
    },
    'REMOVE_GROUP_MEMBER': function REMOVE_GROUP_MEMBER(state, _ref3) {
        var group = _ref3.group,
            member = _ref3.member,
            _ref3$index = _ref3.index,
            index = _ref3$index === undefined ? null : _ref3$index,
            _ref3$memberIndex = _ref3.memberIndex,
            memberIndex = _ref3$memberIndex === undefined ? null : _ref3$memberIndex;

        if (index === null || index >= state.groups.length) {
            index = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.indexOf(state.groups, group);
        }

        if (index !== -1) {
            var members = state.groups[index].members;

            if (memberIndex === null || index >= members.lenth) {
                memberIndex = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.indexOf(members, member);
            }

            if (memberIndex !== -1) {
                members.splice(memberIndex, 1);

                state.groups[index].members = members;
            }
        }
    },
    'INSERT_GROUP_MEMBER': function INSERT_GROUP_MEMBER(state, _ref4) {
        var group = _ref4.group,
            member = _ref4.member,
            _ref4$index = _ref4.index,
            index = _ref4$index === undefined ? null : _ref4$index;

        if (index === null || index >= state.groups.length) {
            index = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.indexOf(state.groups, group);
        }

        if (index !== -1) {
            if (state.groups[index].members === null) {
                state.groups[index].members = [];
            }

            state.groups[index].members = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.unionBy(state.groups[index].members, [member], 'id');
        }
    },
    'UPDATE_GROUP_NAME': function UPDATE_GROUP_NAME(state, _ref5) {
        var group = _ref5.group,
            _ref5$index = _ref5.index,
            index = _ref5$index === undefined ? null : _ref5$index;

        if (index === null || index >= state.groups.length) {
            index = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.indexOf(state.groups, group);
        }

        if (index !== -1) {
            state.groups[index] = group;
        }
    },
    'SET_ACTIVE_GROUP': function SET_ACTIVE_GROUP(state, _ref6) {
        var group = _ref6.group,
            _ref6$index = _ref6.index,
            index = _ref6$index === undefined ? null : _ref6$index;

        if (index === null || index >= state.groups.length) {
            index = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.indexOf(state.groups, group);
        }

        state.active = index;
    },
    'GROUP_RESET': function GROUP_RESET(state) {
        state = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(state, getInitialState());
    }
};

var actions = {
    group_list: function group_list(_ref7) {
        var commit = _ref7.commit;

        __WEBPACK_IMPORTED_MODULE_2_vue__["default"].http.get('groups').then(function (response) {
            commit('INSERT_GROUP_LIST', response.body.data);
        }).catch(function (error) {
            __WEBPACK_IMPORTED_MODULE_4__bugsnag__["a" /* default */].notify(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(error));
        });
    },
    group_post: function group_post(_ref8, name) {
        var commit = _ref8.commit;

        __WEBPACK_IMPORTED_MODULE_2_vue__["default"].http.post('groups', { name: name }).then(function (response) {
            commit('INSERT_GROUP', response.body.data);
        }).catch(function (error) {
            __WEBPACK_IMPORTED_MODULE_4__bugsnag__["a" /* default */].notify(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(error));
        });
    },
    group_put: function group_put(_ref9, _ref10) {
        var commit = _ref9.commit;
        var group = _ref10.group,
            _ref10$workarea = _ref10.workarea,
            workarea = _ref10$workarea === undefined ? null : _ref10$workarea;

        __WEBPACK_IMPORTED_MODULE_2_vue__["default"].http.put('group/' + group.id, { name: group.name, workarea: workarea }).then(function (resposne) {
            commit('UPDATE_GROUP_NAME', { group: group });
        }).catch(function (error) {
            __WEBPACK_IMPORTED_MODULE_4__bugsnag__["a" /* default */].notify(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(error));
        });
    },
    group_members: function group_members(_ref11, _ref12) {
        var commit = _ref11.commit;
        var group = _ref12.group,
            index = _ref12.index;

        __WEBPACK_IMPORTED_MODULE_2_vue__["default"].http.get('group/' + group.id + '/members').then(function (response) {
            commit('INSERT_GROUP_MEMBER_LIST', { group: group, members: response.body.data, index: index });
        }).catch(function (error) {
            __WEBPACK_IMPORTED_MODULE_4__bugsnag__["a" /* default */].notify(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(error));
        });
    },
    group_member_delete: function group_member_delete(_ref13, _ref14) {
        var commit = _ref13.commit;
        var group = _ref14.group,
            index = _ref14.index,
            member = _ref14.member,
            memberIndex = _ref14.memberIndex;

        __WEBPACK_IMPORTED_MODULE_2_vue__["default"].http.delete('group/' + group.id + '/member/' + member.id).then(function (response) {
            commit('REMOVE_GROUP_MEMBER', { group: group, member: member, index: index, memberIndex: memberIndex });
        }).catch(function (error) {
            __WEBPACK_IMPORTED_MODULE_4__bugsnag__["a" /* default */].notify(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(error));
        });
    },
    group_member_post: function group_member_post(_ref15, _ref16) {
        var commit = _ref15.commit;
        var group = _ref16.group,
            username = _ref16.username,
            index = _ref16.index;

        __WEBPACK_IMPORTED_MODULE_2_vue__["default"].http.post('group/' + group.id + '/members', { username: username }).then(function (response) {
            commit('INSERT_GROUP_MEMBER', { group: group, member: response.body.data, index: index });
        }).catch(function (error) {
            __WEBPACK_IMPORTED_MODULE_4__bugsnag__["a" /* default */].notify(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(error));
        });
    },
    group_delete: function group_delete(_ref17, _ref18) {
        var commit = _ref17.commit;
        var group = _ref18.group,
            index = _ref18.index;

        __WEBPACK_IMPORTED_MODULE_2_vue__["default"].http.delete('group/' + group.id).then(function (response) {
            commit('REMOVE_GROUP', { group: group, index: index });
        });
    },
    group_select: function group_select(_ref19, _ref20) {
        var commit = _ref19.commit;
        var group = _ref20.group,
            index = _ref20.index;

        commit('SET_ACTIVE_GROUP', { group: group, index: index });
    }
};

var getters = {
    getActiveGroup: function getActiveGroup(state) {
        var group = state.groups[state.active];

        if (group !== undefined && (group.members === undefined || group.members === null)) {
            group.members = [];
        }

        return group;
    }
};

/* harmony default export */ __webpack_exports__["a"] = ({
    state: state,
    mutations: mutations,
    actions: actions,
    getters: getters
});

/***/ }),

/***/ 293:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__bugsnag__ = __webpack_require__(29);






function getInitialState() {
    return {
        workareas: [],
        active: -1
    };
}

var state = getInitialState();

var mutations = {
    'INSERT_WORKAREA_LIST': function INSERT_WORKAREA_LIST(state, workareas) {
        __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.each(workareas, function (workarea) {
            if (workarea.members === null || workarea.members === undefined) {
                workarea.members = [];
            }
        });

        state.workareas = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.unionBy(state.workareas, workareas, 'id');
    },
    'REMOVE_WORKAREA': function REMOVE_WORKAREA(state, _ref) {
        var workarea = _ref.workarea,
            _ref$index = _ref.index,
            index = _ref$index === undefined ? null : _ref$index;

        if (index !== null && index < state.workareas.length) {
            state.workareas.splice(index, 1);
        } else if (index === null) {
            __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.remove(state.workareas, function (elem) {
                return elem.id === workarea.id;
            });
        }
    },
    'INSERT_WORKAREA': function INSERT_WORKAREA(state, workarea) {
        if (workarea.members === null || workarea.members === undefined) {
            workarea.members = [];
        }

        state.workareas = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.unionBy(state.workareas, [workarea], 'id');
    },
    'INSERT_WORKAREA_MEMBER_LIST': function INSERT_WORKAREA_MEMBER_LIST(state, _ref2) {
        var workarea = _ref2.workarea,
            members = _ref2.members,
            _ref2$index = _ref2.index,
            index = _ref2$index === undefined ? null : _ref2$index;

        if (index === null || index >= state.workareas.length) {
            index = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.indexOf(state.workareas, workarea);
        }

        if (index !== -1) {
            state.workareas[index].members = members;
        }
    },
    'REMOVE_WORKAREA_MEMBER': function REMOVE_WORKAREA_MEMBER(state, _ref3) {
        var workarea = _ref3.workarea,
            member = _ref3.member,
            _ref3$index = _ref3.index,
            index = _ref3$index === undefined ? null : _ref3$index,
            _ref3$memberIndex = _ref3.memberIndex,
            memberIndex = _ref3$memberIndex === undefined ? null : _ref3$memberIndex;

        if (index === null || index >= state.workareas.length) {
            index = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.indexOf(state.workareas, workarea);
        }

        if (index !== -1) {
            var members = state.workareas[index].members;

            if (memberIndex === null || index >= members.lenth) {
                memberIndex = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.indexOf(members, member);
            }

            if (memberIndex !== -1) {
                members.splice(memberIndex, 1);

                state.workareas[index].members = members;
            }
        }
    },
    'INSERT_WORKAREA_MEMBER': function INSERT_WORKAREA_MEMBER(state, _ref4) {
        var workarea = _ref4.workarea,
            member = _ref4.member,
            _ref4$index = _ref4.index,
            index = _ref4$index === undefined ? null : _ref4$index;

        if (index === null || index >= state.workareas.length) {
            index = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.indexOf(state.workareas, workarea);
        }

        if (index !== -1) {
            if (state.workareas[index].members === null) {
                state.workareas[index].members = [];
            }

            state.workareas[index].members = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.unionBy(state.workareas[index].members, [member], 'id');
        }
    },
    'UPSERT_WORKAREA_MEMBER': function UPSERT_WORKAREA_MEMBER(state, _ref5) {
        var workarea = _ref5.workarea,
            member = _ref5.member,
            _ref5$index = _ref5.index,
            index = _ref5$index === undefined ? null : _ref5$index;

        if (index === null || index >= state.workareas.length) {
            index = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.indexOf(state.workareas, workarea);
        }

        if (index !== -1) {
            if (state.workareas[index].members === null) {
                state.workareas[index].members = [member];
            } else {
                state.workareas[index].members = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.unionBy([member], state.workareas[index].members, 'id');
            }
        }
    },
    'UPDATE_WORKAREA_NAME': function UPDATE_WORKAREA_NAME(state, _ref6) {
        var workarea = _ref6.workarea,
            _ref6$index = _ref6.index,
            index = _ref6$index === undefined ? null : _ref6$index;

        if (index === null || index >= state.workareas.length) {
            index = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.indexOf(state.workareas, workarea);
        }

        if (index !== -1) {
            state.workareas[index] = workarea;
        }
    },
    'SET_ACTIVE_WORKAREA': function SET_ACTIVE_WORKAREA(state, _ref7) {
        var workarea = _ref7.workarea,
            _ref7$index = _ref7.index,
            index = _ref7$index === undefined ? null : _ref7$index;

        if (index === null || index >= state.workareas.length) {
            index = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.indexOf(state.workareas, workarea);
        }

        state.active = index;
    },
    'WORKAREA_RESET': function WORKAREA_RESET(state) {
        state = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(state, getInitialState());
    }
};

var actions = {
    workarea_list: function workarea_list(_ref8) {
        var commit = _ref8.commit,
            dispatch = _ref8.dispatch;

        __WEBPACK_IMPORTED_MODULE_2_vue__["default"].http.get('workspaces').then(function (response) {
            commit('INSERT_WORKAREA_LIST', response.body.data);

            __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.each(response.body.data, function (workarea) {
                dispatch('workarea_members', { workarea: workarea, index: null });
            });
        }).catch(function (error) {
            __WEBPACK_IMPORTED_MODULE_4__bugsnag__["a" /* default */].notify(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(error));
        });
    },
    workarea_post: function workarea_post(_ref9, name) {
        var commit = _ref9.commit;

        __WEBPACK_IMPORTED_MODULE_2_vue__["default"].http.post('workspaces', { name: name }).then(function (response) {
            commit('INSERT_WORKAREA', response.body.data);
        }).catch(function (error) {
            __WEBPACK_IMPORTED_MODULE_4__bugsnag__["a" /* default */].notify(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(error));
        });
    },
    workarea_put: function workarea_put(_ref10, workarea) {
        var commit = _ref10.commit;

        __WEBPACK_IMPORTED_MODULE_2_vue__["default"].http.put('workspace/' + workarea.id, { name: workarea.name }).then(function (resposne) {
            commit('UPDATE_WORKAREA_NAME', { workarea: workarea });
        }).catch(function (error) {
            __WEBPACK_IMPORTED_MODULE_4__bugsnag__["a" /* default */].notify(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(error));
        });
    },
    workarea_members: function workarea_members(_ref11, _ref12) {
        var commit = _ref11.commit;
        var workarea = _ref12.workarea,
            index = _ref12.index;

        __WEBPACK_IMPORTED_MODULE_2_vue__["default"].http.get('workspace/' + workarea.id + '/members').then(function (response) {
            commit('INSERT_WORKAREA_MEMBER_LIST', { workarea: workarea, members: response.body.data, index: index });
        }).catch(function (error) {
            __WEBPACK_IMPORTED_MODULE_4__bugsnag__["a" /* default */].notify(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(error));
        });
    },
    workarea_member_delete: function workarea_member_delete(_ref13, _ref14) {
        var commit = _ref13.commit;
        var workarea = _ref14.workarea,
            index = _ref14.index,
            member = _ref14.member,
            memberIndex = _ref14.memberIndex;

        __WEBPACK_IMPORTED_MODULE_2_vue__["default"].http.delete('workspace/' + workarea.id + '/member/' + member.id).then(function (response) {
            commit('REMOVE_WORKAREA_MEMBER', { workarea: workarea, member: member, index: index, memberIndex: memberIndex });
        }).catch(function (error) {
            __WEBPACK_IMPORTED_MODULE_4__bugsnag__["a" /* default */].notify(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(error));
        });
    },
    workarea_member_post: function workarea_member_post(_ref15, _ref16) {
        var commit = _ref15.commit;
        var workarea = _ref16.workarea,
            username = _ref16.username,
            index = _ref16.index;

        __WEBPACK_IMPORTED_MODULE_2_vue__["default"].http.post('workspace/' + workarea.id + '/members', { username: username }).then(function (response) {
            commit('INSERT_WORKAREA_MEMBER', { workarea: workarea, member: response.body.data, index: index });
        }).catch(function (error) {
            __WEBPACK_IMPORTED_MODULE_4__bugsnag__["a" /* default */].notify(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(error));
        });
    },
    workarea_delete: function workarea_delete(_ref17, _ref18) {
        var commit = _ref17.commit;
        var workarea = _ref18.workarea,
            index = _ref18.index;

        __WEBPACK_IMPORTED_MODULE_2_vue__["default"].http.delete('workspace/' + workarea.id).then(function (response) {
            commit('REMOVE_WORKAREA', { workarea: workarea, index: index });
        });
    },
    workarea_select: function workarea_select(_ref19, _ref20) {
        var commit = _ref19.commit;
        var workarea = _ref20.workarea,
            index = _ref20.index;

        commit('SET_ACTIVE_WORKAREA', { workarea: workarea, index: index });
    },
    workarea_silent: function workarea_silent(_ref21, _ref22) {
        var commit = _ref21.commit;
        var workarea = _ref22.workarea,
            user = _ref22.user,
            silent = _ref22.silent;

        __WEBPACK_IMPORTED_MODULE_2_vue__["default"].http.put('workspace/' + workarea.id + '/member/' + user.id, { silent: silent }).then(function (response) {
            commit('UPSERT_WORKAREA_MEMBER', { workarea: workarea, member: response.body.data, index: null });
        }).catch(function (error) {
            __WEBPACK_IMPORTED_MODULE_4__bugsnag__["a" /* default */].notify(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(error));
        });
    }
};

var getters = {
    getActiveWorkarea: function getActiveWorkarea(state) {
        return state.workareas[state.active];
    },
    getWorkareas: function getWorkareas(state) {
        return state.workareas;
    }
};

/* harmony default export */ __webpack_exports__["a"] = ({
    state: state,
    mutations: mutations,
    actions: actions,
    getters: getters
});

/***/ }),

/***/ 294:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);

function getInitialState() {
    return {
        statuses: [1, 4],
        workarea: null
    };
}

var state = getInitialState();

var mutations = {
    'FILTER_SET_STATUSES': function FILTER_SET_STATUSES(state, statuses) {
        state.statuses = statuses;
    },
    'FILTER_SET_WORKAREA': function FILTER_SET_WORKAREA(state, workarea) {
        state.workarea = workarea;
    },
    'FILTER_RESET': function FILTER_RESET(state) {
        state = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(state, getInitialState());
    }
};

var getters = {
    getFilters: function getFilters(state) {
        return { statuses: state.statuses, workarea: state.workarea };
    }
};

/* harmony default export */ __webpack_exports__["a"] = ({
    state: state,
    mutations: mutations,
    getters: getters
});

/***/ }),

/***/ 295:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__bugsnag__ = __webpack_require__(29);






function getInitialState() {
    return {
        favorites: []
    };
}

var state = getInitialState();

var mutations = {
    'INSERT_FAVORITES_LIST': function INSERT_FAVORITES_LIST(state, favorites) {
        state.favorites = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.union(state, favorites);
    },
    'REMOVE_FAVORITE': function REMOVE_FAVORITE(state, _ref) {
        var task = _ref.task,
            _ref$index = _ref.index,
            index = _ref$index === undefined ? null : _ref$index;

        if (index !== null && index < state.favorites.length) {
            state.favorites.splice(index, 1);
        } else {
            index = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.findIndex(state.favorites, task.id);

            state.favorites.splice(index, 1);
        }
    },
    'INSERT_FAVORITE': function INSERT_FAVORITE(state, task) {
        state.favorites = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.union(state.favorites, [task.id]);
    },
    'RESET_FAVORITES': function RESET_FAVORITES(state) {
        state = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(state, getInitialState());
    }
};

var actions = {
    favorites_list: function favorites_list(_ref2) {
        var commit = _ref2.commit,
            state = _ref2.state;

        __WEBPACK_IMPORTED_MODULE_2_vue__["default"].http.get('favorites').then(function (response) {
            commit('INSERT_FAVORITES_LIST', response.body.data);
        }).catch(function (error) {
            __WEBPACK_IMPORTED_MODULE_4__bugsnag__["a" /* default */].notify(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(error));
        });
    },
    favorites_remove: function favorites_remove(_ref3, task) {
        var commit = _ref3.commit,
            state = _ref3.state;

        __WEBPACK_IMPORTED_MODULE_2_vue__["default"].http.delete('favorite/' + task.id).then(function (response) {
            commit('REMOVE_FAVORITE', { task: task });
        }).catch(function (error) {
            __WEBPACK_IMPORTED_MODULE_4__bugsnag__["a" /* default */].notify(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(error));
        });
    },
    favorites_clear: function favorites_clear(_ref4) {
        var commit = _ref4.commit,
            state = _ref4.state;

        __WEBPACK_IMPORTED_MODULE_2_vue__["default"].http.delete('favorites').then(function (response) {
            commit('RESET_FAVORITES');
        }).catch(function (error) {
            __WEBPACK_IMPORTED_MODULE_4__bugsnag__["a" /* default */].notify(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(error));
        });
    },
    favorites_insert: function favorites_insert(_ref5, task) {
        var commit = _ref5.commit,
            state = _ref5.state;

        __WEBPACK_IMPORTED_MODULE_2_vue__["default"].http.post('favorites', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({ tasks: [task.id] })).then(function (response) {
            commit('INSERT_FAVORITE', task);
        }).catch(function (error) {
            __WEBPACK_IMPORTED_MODULE_4__bugsnag__["a" /* default */].notify(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(error));
        });
    }
};

var getters = {
    getFavorites: function getFavorites(state) {
        return state.favorites;
    },
    checkFavorited: function checkFavorited(state, getters) {
        return function (task) {
            return __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.findIndex(state.favorites, task.id) > -1;
        };
    }
};

/* harmony default export */ __webpack_exports__["a"] = ({
    state: state,
    mutations: mutations,
    actions: actions,
    getters: getters
});

/***/ }),

/***/ 296:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__bugsnag__ = __webpack_require__(29);






function getInitialState() {
    return {
        organisations: []
    };
}

var state = getInitialState();

var mutations = {
    'INSERT_ORGANISATION_LIST': function INSERT_ORGANISATION_LIST(state, organisations) {
        __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.each(organisations, function (organisation) {
            if (organisation.members === null || organisation.members === undefined) {
                organisation.members = [];
            }
        });

        state.organisations = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.unionBy(state.organisations, organisations, 'id');
    },
    'REMOVE_ORGANISATION': function REMOVE_ORGANISATION(state, _ref) {
        var organisation = _ref.organisation,
            _ref$index = _ref.index,
            index = _ref$index === undefined ? null : _ref$index;

        if (index !== null && index < state.organisations.length) {
            state.organisations.splice(index, 1);
        } else if (index === null) {
            __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.remove(state.organisations, function (elem) {
                return elem.id === organisation.id;
            });
        }
    },
    'INSERT_ORGANISATION': function INSERT_ORGANISATION(state, organisation) {
        if (organisation.members === null || organisation.members === undefined) {
            organisation.members = [];
        }

        state.organisations = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.unionBy(state.organisations, [organisation], 'id');
    },
    'INSERT_ORGANISATION_MEMBER_LIST': function INSERT_ORGANISATION_MEMBER_LIST(state, _ref2) {
        var organisation = _ref2.organisation,
            members = _ref2.members,
            _ref2$index = _ref2.index,
            index = _ref2$index === undefined ? null : _ref2$index;

        if (index === null || index >= state.organisations.length) {
            index = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.indexOf(state.organisations, organisation);
        }

        if (index !== -1) {
            state.organisations[index].members = members;
        }
    },
    'REMOVE_ORGANISATION_MEMBER': function REMOVE_ORGANISATION_MEMBER(state, _ref3) {
        var organisation = _ref3.organisation,
            member = _ref3.member,
            _ref3$index = _ref3.index,
            index = _ref3$index === undefined ? null : _ref3$index,
            _ref3$memberIndex = _ref3.memberIndex,
            memberIndex = _ref3$memberIndex === undefined ? null : _ref3$memberIndex;

        if (index === null || index >= state.organisations.length) {
            index = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.indexOf(state.organisations, organisation);
        }

        if (index !== -1) {
            var members = state.organisations[index].members;

            if (memberIndex === null || index >= members.lenth) {
                memberIndex = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.indexOf(members, member);
            }

            if (memberIndex !== -1) {
                members.splice(memberIndex, 1);

                state.organisations[index].members = members;
            }
        }
    },
    'INSERT_ORGANISATION_MEMBER': function INSERT_ORGANISATION_MEMBER(state, _ref4) {
        var organisation = _ref4.organisation,
            member = _ref4.member,
            _ref4$index = _ref4.index,
            index = _ref4$index === undefined ? null : _ref4$index;

        if (index === null || index >= state.organisations.length) {
            index = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.indexOf(state.organisations, organisation);
        }

        if (index !== -1) {
            if (state.organisations[index].members === null || state.organisations[index].members === undefined) {
                state.organisations[index].members = [];
            }

            state.organisations[index].members = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.unionBy(state.organisations[index].members, [member], 'user_id');
        }
    },
    'UPSERT_ORGANISATION_MEMBER': function UPSERT_ORGANISATION_MEMBER(state, _ref5) {
        var organisation = _ref5.organisation,
            member = _ref5.member,
            _ref5$index = _ref5.index,
            index = _ref5$index === undefined ? null : _ref5$index;

        if (index === null || index >= state.organisations.length) {
            index = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.indexOf(state.organisations, organisation);
        }

        if (index !== -1) {
            if (state.organisations[index].members === null) {
                state.organisations[index].members = [member];
            } else {
                state.organisations[index].members = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.unionBy([member], state.organisations[index].members, 'user_id');
            }
        }
    },
    'ORGANISATION_RESET': function ORGANISATION_RESET(state) {
        state = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(state, getInitialState());
    }
};

var actions = {
    organisation_list: function organisation_list(_ref6) {
        var commit = _ref6.commit,
            dispatch = _ref6.dispatch;

        __WEBPACK_IMPORTED_MODULE_2_vue__["default"].http.get('organisations').then(function (response) {
            commit('INSERT_ORGANISATION_LIST', response.body.data);

            __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.each(response.body.data, function (organisation) {
                dispatch('organisation_members', { organisation: organisation, index: null });
            });
        }).catch(function (error) {
            __WEBPACK_IMPORTED_MODULE_4__bugsnag__["a" /* default */].notify(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(error));
        });
    },
    organisation_members: function organisation_members(_ref7, _ref8) {
        var commit = _ref7.commit;
        var organisation = _ref8.organisation,
            index = _ref8.index;

        __WEBPACK_IMPORTED_MODULE_2_vue__["default"].http.get('organisation/' + organisation.id + '/members').then(function (response) {
            commit('INSERT_ORGANISATION_MEMBER_LIST', { organisation: organisation, members: response.body.data, index: index });
        }).catch(function (error) {
            __WEBPACK_IMPORTED_MODULE_4__bugsnag__["a" /* default */].notify(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(error));
        });
    },
    organisation_member_delete: function organisation_member_delete(_ref9, _ref10) {
        var commit = _ref9.commit;
        var organisation = _ref10.organisation,
            index = _ref10.index,
            member = _ref10.member,
            memberIndex = _ref10.memberIndex;

        __WEBPACK_IMPORTED_MODULE_2_vue__["default"].http.delete('organisation/' + organisation.id + '/member/' + member.user_id).then(function (response) {
            commit('REMOVE_ORGANISATION_MEMBER', { organisation: organisation, member: member, index: index, memberIndex: memberIndex });
        }).catch(function (error) {
            __WEBPACK_IMPORTED_MODULE_4__bugsnag__["a" /* default */].notify(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(error));
        });
    },
    organisation_member_post: function organisation_member_post(_ref11, _ref12) {
        var commit = _ref11.commit;
        var organisation = _ref12.organisation,
            user = _ref12.user,
            permission = _ref12.permission,
            index = _ref12.index;

        __WEBPACK_IMPORTED_MODULE_2_vue__["default"].http.post('organisation/' + organisation.id + '/members', { username: user, permission: 0 }).then(function (response) {
            commit('INSERT_ORGANISATION_MEMBER', { organisation: organisation, member: response.body.data, index: index });
        }).catch(function (error) {
            __WEBPACK_IMPORTED_MODULE_4__bugsnag__["a" /* default */].notify(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(error));
        });
    },
    organisation_member_permission: function organisation_member_permission(_ref13, _ref14) {
        var commit = _ref13.commit;
        var organisation = _ref14.organisation,
            member = _ref14.member,
            permission = _ref14.permission,
            index = _ref14.index;

        console.log('organisation_member_permission');
        __WEBPACK_IMPORTED_MODULE_2_vue__["default"].http.put('organisation/' + organisation.id + '/member/' + member.user_id, { permission: permission }).then(function (response) {
            member.permission_level = permission;
            commit('UPSERT_ORGANISATION_MEMBER', { organisation: organisation, member: member, index: index });
        }).catch(function (error) {
            __WEBPACK_IMPORTED_MODULE_4__bugsnag__["a" /* default */].notify(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(error));
        });
    },
    organisation_member_password: function organisation_member_password(_ref15, _ref16) {
        var commit = _ref15.commit;
        var organisation = _ref16.organisation,
            member = _ref16.member,
            password = _ref16.password,
            index = _ref16.index;

        __WEBPACK_IMPORTED_MODULE_2_vue__["default"].http.put('organisation/' + organisation.id + '/member/' + member.user_id, { password: password }).then(function (response) {}).catch(function (error) {
            __WEBPACK_IMPORTED_MODULE_4__bugsnag__["a" /* default */].notify(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(error));
        });
    }
};

var getters = {
    getOrganisations: function getOrganisations(state) {
        return state.organisations;
    },
    getOrganisation: function getOrganisation(state) {
        return function (id) {
            var index = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.findIndex(state.organisations, { id: id });
            return state.organisations[index];
        };
    }
};

/* harmony default export */ __webpack_exports__["a"] = ({
    state: state,
    mutations: mutations,
    actions: actions,
    getters: getters
});

/***/ }),

/***/ 297:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Organisations_vue__ = __webpack_require__(298);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_449a504b_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Organisations_vue__ = __webpack_require__(299);
var normalizeComponent = __webpack_require__(10)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Organisations_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_449a504b_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Organisations_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 298:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(13);





/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'organisations',
    computed: {
        organisations: function organisations() {
            return this.$store.state.organisations.organisations;
        }
    },
    data: function data() {
        return {};
    },
    mounted: function mounted() {
        this.refresh();
    },

    methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])({
        refresh: 'organisation_list'
    }))
});

/***/ }),

/***/ 299:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"friends row justify-content-center"},[_c('div',{staticClass:"col-md-8"},[_vm._m(0),_vm._v(" "),_c('table',{staticClass:"table table-bordered table-striped"},[_vm._m(1),_vm._v(" "),_c('tbody',_vm._l((_vm.organisations),function(organisation,index){return _c('tr',[_c('router-link',{attrs:{"tag":"td","active-class":"active","to":'/organisation/' + organisation.id,"exact":""}},[_c('a',[_vm._v(_vm._s(organisation.name))])])],1)}))])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-7"},[_c('h2',[_vm._v("Organisationer")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',[_vm._v("Namn")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 300:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Organisation_vue__ = __webpack_require__(302);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9fc9d150_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Organisation_vue__ = __webpack_require__(303);
function injectStyle (ssrContext) {
  __webpack_require__(301)
}
var normalizeComponent = __webpack_require__(10)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Organisation_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9fc9d150_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Organisation_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 301:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 302:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_parts_Autocomplete__ = __webpack_require__(107);







/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'workarea',
    components: {
        Autocomplete: __WEBPACK_IMPORTED_MODULE_3__components_parts_Autocomplete__["a" /* default */]
    },
    computed: {
        userId: function userId() {
            return this.$store.state.authentication.user.id;
        },
        organisations: function organisations() {
            return this.$store.state.organisations.organisations;
        },
        members: function members() {
            return __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.orderBy(this.organisation.members, 'user');
        },
        organisation: function organisation() {
            return this.$store.getters.getOrganisation(this.$route.params.id);
        },
        index: function index() {
            return __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.indexOf(this.organisations, this.organisation);
        },
        current_member: function current_member() {
            var index = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.findIndex(this.organisation.members, { user_id: this.userId });
            return this.organisation.members[index];
        }
    },
    data: function data() {
        return {
            username: '',
            member: null,
            permissions: [{ text: 'Medlem', value: 0 }, { text: 'Moderator', value: 1 }, { text: 'Administrator', value: 2 }, { text: 'Super Administrator', value: 3 }],
            permission: 0,
            password_member: null,
            password: '',
            email: '',
            passwordConfirm: ''
        };
    },
    mounted: function mounted() {
        this.refresh({ organisation: this.organisation, index: this.index });
    },

    methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])({
        refresh: 'organisation_members',
        remove: 'organisation_member_delete',
        create: 'organisation_member_post',
        update_permission: 'organisation_member_permission',
        update_password: 'organisation_member_password',
        register_member: 'auth_register_member'
    }), Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapGetters */])({
        getFriends: 'getFriendsList'
    }), {
        selectForRemoval: function selectForRemoval(_ref) {
            var organisation = _ref.organisation,
                member = _ref.member,
                index = _ref.index,
                memberIndex = _ref.memberIndex;

            this.member = { organisation: organisation, member: member, index: index, memberIndex: memberIndex };
            this.$refs.removeConfirmation.show();
        },
        removeAction: function removeAction() {
            console.log('REMOVE', this.member);
            this.remove(this.member);
        },
        removeCancel: function removeCancel() {
            this.member = null;
        },
        createUserShow: function createUserShow() {
            this.$refs.createUser.show();
        },
        createUserCancel: function createUserCancel() {
            this.password = '';
            this.passwordConfirm = '';
            this.username = '';
        },
        createUser: function createUser() {
            var _this = this;

            if (this.username.length > 2 && this.password.length > 6 && this.password === this.passwordConfirm) {
                this.register_member({ username: this.username, password: this.password, email: this.email, organisation: this.organisation, permission: 0 }).then(function () {
                    _this.refresh({ organisation: _this.organisation, index: _this.index });
                    _this.password = '';
                    _this.passwordConfirm = '';
                    _this.username = '';
                });
            }
        },
        selectForPassword: function selectForPassword(_ref2) {
            var organisation = _ref2.organisation,
                member = _ref2.member,
                index = _ref2.index,
                memberIndex = _ref2.memberIndex;

            this.password_member = { organisation: organisation, member: member, index: index, memberIndex: memberIndex };
            this.$refs.passwordReset.show();
        },
        changePassword: function changePassword() {
            this.update_password({ organisation: this.organisation, member: this.password_member.member, password: this.password, index: this.index });
        },
        changePasswordCancel: function changePasswordCancel() {
            this.password_member = null;
        },
        memberPermissionLevel: function memberPermissionLevel(member) {
            var level = '';

            switch (member.permission_level) {
                case 0:
                    {
                        level = 'Medlem';
                        break;
                    }
                case 1:
                    {
                        level = 'Moderator';
                        break;
                    }
                case 2:
                    {
                        level = 'Administrator';
                        break;
                    }
                case 3:
                    {
                        level = 'Super Administrator';
                        break;
                    }
            };

            return level;
        },
        updatePermission: function updatePermission(value, member) {
            if (value !== member.permission_level) {
                this.update_permission({ organisation: this.organisation, member: member, permission: value, index: this.index });
            }
        }
    })
});

/***/ }),

/***/ 303:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"workarea row justify-content-center"},[_c('b-modal',{ref:"removeConfirmation",attrs:{"id":"removeConfirmation","title":"Ta bort medlem","close-title":"Nej","ok-title":"Ja"},on:{"ok":_vm.removeAction,"cancel":_vm.removeCancel}},[_c('span',[_vm._v("Vill du ta bort medlemmen?")])]),_vm._v(" "),_c('b-modal',{ref:"passwordReset",attrs:{"id":"passwordReset","title":"Ändra Lösenord","close-title":"Avbryt","ok-title":"Ändra"},on:{"ok":_vm.changePassword,"cancel":_vm.changePasswordCancel}},[_c('b-form-input',{attrs:{"type":"password","name":"password","placeholder":"Lösenord"},model:{value:(_vm.password),callback:function ($$v) {_vm.password=$$v},expression:"password"}})],1),_vm._v(" "),_c('b-modal',{ref:"createUser",attrs:{"id":"createUser","title":"Skapa Användare","close-title":"Avbryt","ok-title":"Skapa"},on:{"ok":_vm.createUser,"cancel":_vm.createUserCancel}},[_c('b-form-fieldset',{attrs:{"label":"Användarnamn","state":_vm.errors.has('username') ? 'danger' : 'success'}},[_c('b-form-input',{directives:[{name:"validate",rawName:"v-validate:username.initial",value:('required|alpha_num|min:2'),expression:"'required|alpha_num|min:2'",arg:"username",modifiers:{"initial":true}}],attrs:{"name":"username","placeholder":"Användarnamn"},model:{value:(_vm.username),callback:function ($$v) {_vm.username=$$v},expression:"username"}})],1),_vm._v(" "),_c('b-form-fieldset',{attrs:{"label":"Lösenord","state":(_vm.errors.has('password:required') || _vm.errors.has('password:min')) ? 'danger' : 'success'}},[_c('b-form-input',{directives:[{name:"validate",rawName:"v-validate:password.initial",value:('required|min:6|confirmed:confirm'),expression:"'required|min:6|confirmed:confirm'",arg:"password",modifiers:{"initial":true}}],attrs:{"type":"password","name":"password","placeholder":"Lösenord"},model:{value:(_vm.password),callback:function ($$v) {_vm.password=$$v},expression:"password"}})],1),_vm._v(" "),_c('b-form-fieldset',{attrs:{"label":"Repetera lösenord","state":_vm.errors.has('password:confirmed') ? 'danger' : 'success'}},[_c('b-form-input',{attrs:{"type":"password","name":"confirm","placeholder":"Repetera lösenord"},model:{value:(_vm.passwordConfirm),callback:function ($$v) {_vm.passwordConfirm=$$v},expression:"passwordConfirm"}})],1),_vm._v(" "),_c('b-form-fieldset',{attrs:{"label":"E-mail","state":_vm.errors.has('email') ? 'danger' : 'success'}},[_c('b-form-input',{directives:[{name:"validate",rawName:"v-validate:email.initial",value:('required|email'),expression:"'required|email'",arg:"email",modifiers:{"initial":true}}],attrs:{"type":"email","name":"email","placeholder":"E-mail"},model:{value:(_vm.email),callback:function ($$v) {_vm.email=$$v},expression:"email"}})],1)],1),_vm._v(" "),_c('div',{staticClass:"col-md-8"},[_c('div',{staticClass:"row"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"col-sm-5"},[_c('div',{staticClass:"input-group"},[_c('Autocomplete',{attrs:{"options":_vm.getFriends()},scopedSlots:_vm._u([{key:"item",fn:function(option){return [_c('p',[_c('strong',[_vm._v(_vm._s(option.title))])])]}}]),model:{value:(_vm.username),callback:function ($$v) {_vm.username=$$v},expression:"username"}}),_vm._v(" "),_c('span',{staticClass:"input-group-btn"},[_c('button',{staticClass:"btn btn-md btn-primary",attrs:{"type":"button"},on:{"click":function($event){_vm.create({organisation: _vm.organisation, user: _vm.username, permission: 0, index: _vm.index})}}},[_vm._v("Lägg till")])])],1)]),_vm._v(" "),_c('div',{staticClass:"col-sm-1 fix"},[_c('button',{staticClass:"btn btn-md btn-primary",attrs:{"type":"button"},on:{"click":function($event){_vm.createUserShow()}}},[_vm._v("Ny")])])]),_vm._v(" "),_c('table',{staticClass:"table table-bordered table-striped"},[_vm._m(1),_vm._v(" "),_c('tbody',_vm._l((_vm.members),function(member,memberIndex){return _c('tr',[(member.user_id === _vm.userId || _vm.current_member.permission_level < 1)?_c('td',[_vm._v(_vm._s(member.user))]):_c('td',[(member.user_id !== _vm.userId)?_c('a',{attrs:{"href":"#"},on:{"click":function($event){$event.stopPropagation();$event.preventDefault();_vm.selectForPassword({organisation: _vm.organisation, member: member, index: _vm.index, memberIndex: memberIndex})}}},[_vm._v(_vm._s(member.user))]):_vm._e()]),_vm._v(" "),(member.user_id === _vm.userId)?_c('td',[_vm._v(_vm._s(_vm.memberPermissionLevel(member)))]):_c('td',[_c('b-form-select',{staticClass:"mb-3",attrs:{"value":member.permission_level,"options":_vm.permissions},on:{"input":function (value) { return _vm.updatePermission(value, member); }}})],1),_vm._v(" "),_c('td',[(member.user_id !== _vm.userId)?_c('button',{staticClass:"btn btn-primary",on:{"click":function($event){_vm.selectForRemoval({organisation: _vm.organisation, member: member, index: _vm.index, memberIndex: memberIndex})}}},[_vm._v("Ta bort")]):_vm._e()])])}))])])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-sm-6"},[_c('h2',[_vm._v("Medlemmar")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',[_vm._v("Namn")]),_vm._v(" "),_c('th',[_vm._v("Nivå")]),_vm._v(" "),_c('th',[_vm._v("Hantera")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 304:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_User_vue__ = __webpack_require__(305);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0b366e9e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_User_vue__ = __webpack_require__(306);
var normalizeComponent = __webpack_require__(10)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_User_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0b366e9e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_User_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 305:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(13);




/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'Login',
    data: function data() {
        return {
            password: null,
            email: null,
            workarea: null,
            showDismissableAlert: false,
            alertContents: 'Vi kunde inte uppdatera dina uppgifter just nu. Försök igen senare.'
        };
    },

    computed: {
        user: function user() {
            return this.$store.state.authentication.user;
        },
        workareas: function workareas() {
            return this.$store.state.workarea.workareas;
        }
    },
    methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])({
        update: 'auth_update'
    }), {
        submit: function submit() {
            var _this = this;

            this.$validator.validateAll().then(function () {
                _this.update({ user: _this.user, password: _this.password, email: _this.email, workarea: _this.workarea });
            });
        },
        setWorkarea: function setWorkarea(value) {
            this.workarea = value;
        }
    })
});

/***/ }),

/***/ 306:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"register row justify-content-center"},[_c('div',{staticClass:"col-md-6"},[_c('b-alert',{attrs:{"variant":"danger","dismissible":"","show":_vm.showDismissableAlert},on:{"dismissed":function($event){_vm.showDismissableAlert=false}}},[_vm._v("\n                "+_vm._s(_vm.alertContents)+"\n        ")]),_vm._v(" "),_c('form',{on:{"submit":function($event){$event.preventDefault();_vm.submit($event)}}},[_c('b-form-fieldset',{attrs:{"label":"Lösenord","state":_vm.errors.has('password:min') ? 'danger' : 'success'}},[_c('b-form-input',{directives:[{name:"validate",rawName:"v-validate:password.initial",value:('min:6|confirmed:confirm'),expression:"'min:6|confirmed:confirm'",arg:"password",modifiers:{"initial":true}}],attrs:{"type":"password","name":"password","placeholder":"Lösenord"},model:{value:(_vm.password),callback:function ($$v) {_vm.password=$$v},expression:"password"}})],1),_vm._v(" "),_c('b-form-fieldset',{attrs:{"label":"Repetera lösenord","state":_vm.errors.has('password:confirmed') ? 'danger' : 'success'}},[_c('b-form-input',{attrs:{"type":"password","name":"confirm","placeholder":"Repetera lösenord"}})],1),_vm._v(" "),_c('b-form-fieldset',{attrs:{"label":"Yta"}},[_c('b-form-select',{staticClass:"mb-3",attrs:{"text-field":"name","value-field":"id","value":_vm.user.workarea,"options":_vm.workareas},on:{"input":function (value) { return _vm.setWorkarea(value); }}})],1),_vm._v(" "),_c('b-button',{attrs:{"block":true,"variant":"primary","size":"lg","type":"submit"}},[_vm._v("Uppdatera")])],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 307:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('b-navbar',{attrs:{"toggleable":"md","type":"dark","fixed":"top","variant":"success"}},[_c('b-nav-toggle',{attrs:{"target":"nav_collapse"}}),_vm._v(" "),_c('b-link',{staticClass:"navbar-brand",attrs:{"to":"/"}},[_c('span',[_vm._v("PlusFlow")])]),_vm._v(" "),_c('b-collapse',{staticStyle:{"width":"60%"},attrs:{"is-nav":"","id":"nav_collapse"}},[_c('b-navbar-nav',[(_vm.authenticated)?_c('b-nav-item',{attrs:{"to":"/friends"}},[_vm._v("Friends")]):_vm._e(),_vm._v(" "),(_vm.authenticated)?_c('b-nav-item',{attrs:{"to":"/groups"}},[_vm._v("Groups")]):_vm._e(),_vm._v(" "),(_vm.authenticated)?_c('b-nav-item',{attrs:{"to":"/workareas"}},[_vm._v("Workareas")]):_vm._e(),_vm._v(" "),(_vm.authenticated)?_c('b-nav-item',{attrs:{"to":"/organisations"}},[_vm._v("Organisations")]):_vm._e(),_vm._v(" "),(!_vm.authenticated)?_c('b-nav-item',{attrs:{"to":"/login"}},[_vm._v("Login")]):_vm._e(),_vm._v(" "),(_vm.authenticated)?_c('b-nav-item',{attrs:{"to":"logout"},on:{"click":_vm.logout}},[_vm._v("Logout")]):_vm._e()],1),_vm._v(" "),_c('b-navbar-nav',{staticClass:"ml-auto"},[(_vm.authenticated)?_c('b-nav-item',{attrs:{"to":"#"},on:{"click":_vm.refresh}},[_c('i',{staticClass:"material-icons"},[_vm._v("")])]):_vm._e(),_vm._v(" "),(_vm.authenticated)?_c('b-nav-item',{attrs:{"to":"/user"}},[_vm._v(_vm._s(_vm.user.username))]):_vm._e()],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"container"},[_c('router-view')],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 309:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 517:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 518:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 78:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Main__ = __webpack_require__(208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Login__ = __webpack_require__(242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Friends__ = __webpack_require__(248);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Groups__ = __webpack_require__(252);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Workareas__ = __webpack_require__(255);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Workarea__ = __webpack_require__(258);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Group__ = __webpack_require__(264);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_Task__ = __webpack_require__(269);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__vuex_store__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_Organisations__ = __webpack_require__(297);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_Organisation__ = __webpack_require__(300);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_User__ = __webpack_require__(304);















__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

var router = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
    routes: [{
        path: '/',
        name: 'Main',
        component: __WEBPACK_IMPORTED_MODULE_2__components_Main__["a" /* default */]
    }, {
        path: '/friends',
        name: 'Friends',
        component: __WEBPACK_IMPORTED_MODULE_4__components_Friends__["a" /* default */]
    }, {
        path: '/login',
        name: 'Login',
        component: __WEBPACK_IMPORTED_MODULE_3__components_Login__["a" /* default */]
    }, {
        path: '/groups',
        name: 'Groups',
        component: __WEBPACK_IMPORTED_MODULE_5__components_Groups__["a" /* default */]
    }, {
        path: '/workareas',
        name: 'Workareas',
        component: __WEBPACK_IMPORTED_MODULE_6__components_Workareas__["a" /* default */]
    }, {
        path: '/organisations',
        name: 'Organisations',
        component: __WEBPACK_IMPORTED_MODULE_11__components_Organisations__["a" /* default */]
    }, {
        path: '/organisation/:id',
        name: 'Organisation',
        component: __WEBPACK_IMPORTED_MODULE_12__components_Organisation__["a" /* default */]
    }, {
        path: '/workarea/:id',
        name: 'Workarea',
        component: __WEBPACK_IMPORTED_MODULE_7__components_Workarea__["a" /* default */]
    }, {
        path: '/group/:id',
        name: 'Group',
        component: __WEBPACK_IMPORTED_MODULE_8__components_Group__["a" /* default */]
    }, {
        path: '/task/:id',
        name: 'Task',
        component: __WEBPACK_IMPORTED_MODULE_9__components_Task__["a" /* default */]
    }, {
        path: '/user',
        name: 'User',
        component: __WEBPACK_IMPORTED_MODULE_13__components_User__["a" /* default */]
    }]
});

router.beforeEach(function (to, from, next) {
    if (to.name !== 'Login' && to.name !== 'Register' && !__WEBPACK_IMPORTED_MODULE_10__vuex_store__["a" /* default */].state.authentication.authenticated) {
        next('/login');
    } else {
        next();
    }
});

router.beforeEach(function (to, from, next) {
    if (from.name === 'Task') {
        __WEBPACK_IMPORTED_MODULE_10__vuex_store__["a" /* default */].commit('REMOVE_ACTIVE_TASK');
    }

    next();
});

router.onReady(function () {
    if (__WEBPACK_IMPORTED_MODULE_10__vuex_store__["a" /* default */].state.authentication.authenticated) {
        __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.headers.common['Authorization'] = 'Bearer ' + __WEBPACK_IMPORTED_MODULE_10__vuex_store__["a" /* default */].state.authentication.token;
    }
});

/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ })

},[194]);


// WEBPACK FOOTER //
// static/js/app.47a02deee8289ab06ced.js